import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  signal,
  ViewChild,
  OnDestroy,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { QueryBuilderClassNames, QueryBuilderComponent, QueryBuilderConfig } from 'angular2-query-builder';
import { cloneDeep, startCase } from 'lodash-es';
import { MessageService } from 'primeng/api';
import { distinctUntilChanged, from, Observable, Subscription } from 'rxjs';
import { rolesTable } from 'src/app/STORE/selectors/roles.selector';
import { allIdMaps, queryMapData, setPageVariables } from 'src/app/STORE/selectors/screens.selector';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { AppLoaderService } from 'src/app/services/app-loader.service';
import { queryBuilderClassNames } from './vs-query-builder-classnames';
import { Operators, VsQueryBuilderService } from './vs-query-builder.service';
import { v4 as uuidv4 } from 'uuid';
import { ApiConstants } from 'src/app/base/api-constants';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { GlobalConstants } from 'src/app/base/global.constants';
import { HttpClient } from '@angular/common/http';
import { UtilService } from 'src/app/services/util.service';
import { allQueries, qbProperties, qbQueries } from 'src/app/STORE/selectors/queryBuilder.selector';
import { getAllQueries, getQBQueries, setAllQueries, setQBQueries } from 'src/app/STORE/actions/queryBuilder.actions';
import { getIdMapping } from 'src/app/STORE/actions/screens.actions';
import * as utilEnum from 'src/app/services/util.enum';
import { metaInfo } from 'src/app/STORE/selectors/applifecycle.selector';
import { AllowedFieldsConstants } from 'src/app/base/allowed-fields.constants';
import { technologystackData } from 'src/app/STORE/selectors/technologystack.selector';
import { ReferenceUtilService } from 'src/app/components/reference-tree-view/reference-util.service';
import { ModelType, ActionType, UiActions } from 'src/app/components/reference-tree-view/reference.enum';

@Component({
  selector: 'vb-vs-qb-builder',
  templateUrl: './vs-qb-builder.component.html',
  styleUrls: ['./vs-qb-builder.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => VsQbBuilderComponent),
      multi: true
    }
  ],
  standalone: false //NOSONAR
})
export class VsQbBuilderComponent implements OnInit, OnChanges, OnDestroy {
  private confirmationDialogService = inject(ConfirmationDialogService);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private store = inject(Store);
  private ms = inject(MessageService);
  private cd = inject(ChangeDetectorRef);
  private qbService = inject(VsQueryBuilderService);
  private loader = inject(AppLoaderService);
  private zone = inject(NgZone);
  private appGlobalService = inject(AppGlobalService);
  private http = inject(HttpClient);
  private baseService = inject(HttpBaseService);
  private util = inject(UtilService);
  private translate = inject(TranslateService);
  private referenceUtil = inject(ReferenceUtilService);

  get isBetaAccessPrivilegeConsumable(): boolean {
    return this.appGlobalService.betaAccessPrivilegeForApp;
  }

  @Input() element: any;
  @Input() workflowName: any;
  @Input() actionProp: any;
  @Input() currentScreen: any = null;
  @Input() currentNode;
  @Input() formData = null;
  @Input() disableField = false;
  @Input() techStack: any;
  @Input() CurrentPicklist: any;
  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  currentInputGroup: any;
  @ViewChild('querybuilder') qryBldrObj: QueryBuilderComponent;
  subscriptions: Subscription[] = [];
  qbProperties$: Observable<any> = this.store.select(qbProperties);
  qbName: string | null = null;
  query: any = null;
  allFields: any = [];
  appUserFieldsInfo: any = [];
  tableFields: any = [];
  description: any = null;
  queryBuilderPropertyName: string;
  bootstrapClassNames: QueryBuilderClassNames = queryBuilderClassNames;
  showQueryBuilder = false;
  selectedId: any = null;
  workflowname: any;
  fieldswarning = '';
  config: QueryBuilderConfig = {
    fields: {},
    addRule: this.addRule.bind(this),
    addRuleSet: this.addRuleSet.bind(this),
    getInputType: this.getInputType.bind(this)
  };
  isQueryExists: boolean;
  activePopupRule: any = null;
  popupType: 'warning' | 'error' | null = null;
  activeRhsPopupRule: any = null;
  rhsPopupType: 'warning' | 'error' | null = null;
  allowRuleset = true;
  allowCollapse = true;
  qbObject: any = null;
  allRoles: any = [];
  qbIconReq = true;
  fieldIdMap: any;
  tableIdMap: any;
  roles: any = [];
  qbFields = {};
  appUserFields: any;
  appUserTableId: any;
  currentTableName: any;
  tablesInfo: any;
  showLoader = false;
  showQueries = false;
  fieldMismatchWarning: string = '';
  leftFields: string = '';
  rightFields: string = '';
  showQueriesSub: Subscription;
  roleFieldTypes = [{ name: 'Value', value: 'value' }];
  fieldTypes = [
    { name: 'Field', value: 'field' },
    { name: 'Value', value: 'value' }
  ];
  rangeFieldTypes = [
    { name: 'Fields', value: 'fields' },
    { name: 'Values', value: 'values' },
    { name: 'Field and Value', value: 'field and value' },
    { name: 'Value and Field', value: 'value and field' }
  ];
  datefieldTypes = [
    { name: 'Value', value: 'value' },
    { name: 'Custom', value: 'custom' },
    { name: 'Page Variables', value: 'pageVariable' },
    { name: '+ days', value: 'plusDays' },
    { name: '- days', value: 'minusDays' }
  ];
  hasInvalidRule = false;
  selectedQuery: any;
  allQueries: any = [];
  isExist = false;

  get isQueryEmpty(): boolean {
    const isRulesEmpty = !this.query || !Array.isArray(this.query.rules) || this.query.rules.length === 0;
    return !this.isExist && !this.qbName && !this.description && isRulesEmpty;
  }

  pageVariables: any[] = [];
  isDatamodelField = false;
  isButtonConditional = false;
  isTableLevelAcl: boolean = false;
  isWorkflowAcl: boolean = false;
  isCudConditional: boolean = false;
  isFromPage: boolean = false;
  backup: any = {};
  references: any = [];
  createAsNew = false;
  usedIn: any = 'FIELD';
  pagename: any;
  addQueryCols = [
    {
      field: 'queryName',
      header: 'QUERY_NAME'
    },
    {
      field: 'queryDescription',
      header: 'DESCRIPTION'
    }
  ];
  referencesCol: any = [];
  isPopupLoader = false;
  isQueryChange = false;
  hasMoreReference = false;
  tabIndex = signal(0);
  queriesMap = {};
  isCurrentTableNeeded = true;
  @Output() public onSave = new EventEmitter();
  @Output() public onCancel = new EventEmitter();
  @Output() public onClear = new EventEmitter();
  @Output() public readonly revert = new EventEmitter();
  message: any = {};
  isDefaultFilter = false;
  showFilterOptions = false;
  allowEdit = false;
  allowView = false;
  holdValue = false;
  selectedRule: any = null;
  holdValDis = false;
  metaInfoMap: any;
  pageVariable: any;
  rulesCopied = false;
  conditionalNames = ['Conditional', 'ConditionalFieldTab', 'WorkflowConditional', 'CUDConditional'];

  constructor() {
    effect(() => {
      this.handleChange(this.tabIndex());
    });
  }

  cancelQb() {
    this.onCancel.emit(true);
  }

  ngOnChanges(): void {
    this.handleConditionalElement();
    this.configureElementProperties();
    this.setQueryNameFromMap();
  }

  private handleConditionalElement(): void {
    if (!this.element) {
      return;
    }

    if (!this.conditionalNames.includes(this.element?.name)) {
      return;
    }

    this.qbIconReq = false;
    this.showLoader = true;
    this.writeValue(this.element.value);
    this.getQueryObject();

    if (this.element?.name === 'ConditionalFieldTab' || this.element?.name === 'Conditional') {
      this.isCurrentTableNeeded = true;
      this.currentTableName = this.qbService.currentTableName;
    }

    this.qbService.configureQBFields({
      roleNeeded: this.element?.isRolesNeeded,
      isAppUserNeeded: this.element.appUserNeeded,
      isCurrentTableNeeded: this.isCurrentTableNeeded,
      isDefaultFilter: this.isDefaultFilter,
      currScr: this.element?.name === 'CUDConditional' ? { name: 'CUD' } : this.currentScreen
    });
    this.toggleQueryBuilder(false);
  }

  private configureElementProperties(): void {
    if (!this.element) {
      return;
    }

    this.setElementFlags();
    this.setReferencesColumns();
    this.setUsedInValue();
    this.checkDefaultFilter();
  }

  private setElementFlags(): void {
    this.isDatamodelField = ['f_editC', 'f_viewC', 'f_cMandatory'].includes(this.element.name);
    this.isTableLevelAcl = this.element.name === 'Conditional';
    this.isWorkflowAcl = this.element.name === 'WorkflowConditional';
    this.isCudConditional = this.element.name === 'CUDConditional';
    this.isButtonConditional = ['conditionForButtonVisiblity', 'conditionForButtonEnable'].includes(this.element.name);
    this.isFromPage =
      this.element.name === 'conditionForButtonEnable' || this.element.name === 'conditionForButtonVisiblity';
  }

  private setReferencesColumns(): void {
    if (this.isDatamodelField) {
      this.referencesCol = [
        { field: 'name', header: 'FIELD_NAME' },
        { field: 'property', header: 'PROPERTY_NAME' }
      ];
    } else if (this.isTableLevelAcl) {
      this.referencesCol = [
        { field: 'role', header: 'Role' },
        { field: 'operation', header: 'ACTION' }
      ];
    } else if (this.isWorkflowAcl || this.isCudConditional) {
      this.referencesCol = [
        { field: 'status', header: 'STATUS' },
        { field: 'actor', header: 'ACTOR' },
        { field: 'action', header: 'ACTION' }
      ];
    } else {
      this.referencesCol = [
        { field: 'pageName', header: 'PAGE' },
        { field: 'elementName', header: 'ACTION' },
        { field: 'property', header: 'PROPERTY_NAME' }
      ];
    }
  }

  private setUsedInValue(): void {
    if (this.isDatamodelField) {
      this.usedIn = 'FIELD';
    } else if (this.isTableLevelAcl) {
      this.usedIn = 'RECORD';
    } else if (this.isFromPage) {
      this.usedIn = 'PAGE';
    } else if (this.isCudConditional) {
      this.usedIn = 'CUD';
    } else {
      this.usedIn = 'WORKFLOW';
    }
  }

  private checkDefaultFilter(): void {
    if (this.element?.lookupTo === 'defaultFilter') {
      this.isDefaultFilter = true;
    }
  }

  private setQueryNameFromMap(): void {
    if (this.queriesMap) {
      this.setQueryName();
    }
  }

  /**
   * Trims leading and trailing spaces in p-chips
   */
  handleChipAdd(event, rule) {
    if (rule?.rhs?.value) {
      rule.rhs.value = [...(rule?.rhs?.value.map((v) => v.trim()) ?? {})];
    }
  }

  setQueryName() {
    if (this.qbObject?.sid && this.metaInfoMap) {
      this.qbName = this.queriesMap[this.qbObject?.sid]
        ? this.queriesMap[this.qbObject?.sid]
        : this.metaInfoMap[this.qbObject?.sid];
    }
  }

  ngOnDestroy(): void {
    //AutoUnsubscribe
    $(this.elementRef.nativeElement).remove();
  }

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.setValueToQueryBuilder(value);
    this.modelValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }

  ngOnInit(): void {
    const queryMapsub = this.store.select(queryMapData).subscribe((queryMap) => {
      if (queryMap) {
        const pVariables = queryMap?.dataGridPageVariables ? queryMap?.dataGridPageVariables : queryMap.pageVariables;
        if (pVariables && pVariables.length > 0) {
          this.pageVariables = [
            ...pVariables.map((m) => {
              return {
                name: m.name,
                value: m.sid,
                type: m.type.toLowerCase()
              };
            })
          ];
        }
      }
    });
    this.currentTableName = this.qbService.currentTableName;
    const rolesSub = this.store.select(rolesTable).subscribe((allTables: any) => {
      if (allTables) {
        this.allRoles = cloneDeep(allTables?.rolesTable ? allTables.rolesTable : allTables.results);
      }
    });
    this.subscriptions.push(queryMapsub);
    const idsSub = this.store.select(allIdMaps).subscribe((res: any) => {
      if (res) {
        if (typeof res.fieldsMap === 'string') {
          this.fieldIdMap = JSON.parse(res.fieldsMap);
          this.tableIdMap = JSON.parse(res.tablesMap);
        } else {
          this.fieldIdMap = res.fieldsMap;
          this.tableIdMap = res.tablesMap;
        }

        // Load Application User fields after tableIdMap is populated
        if (this.tableIdMap) {
          const appUserTableIds = Object.keys(this.tableIdMap).find(
            (key) => this.tableIdMap[key] === 'Application User'
          );
          if (appUserTableIds) {
            const appUserFieldInfoSub = this.baseService
              .get(ApiConstants.getFieldInfo, { tableId: appUserTableIds })
              .subscribe({
                next: (data: any) => {
                  this.appUserFieldsInfo = data;
                },
                error: (err) => {
                  console.error(err);
                }
              });
            this.subscriptions.push(appUserFieldInfoSub);
          }
        }
      } else {
        // Only dispatch getIdMapping if idMaps is not already in the store
        this.store.dispatch(
          getIdMapping({
            getIdMappingApiConstants: ApiConstants.getApplicationDataModelMetaInfo
          })
        );
      }
    });
    this.subscriptions.push(idsSub);
    const metaInfoSub = this.store.select(metaInfo).subscribe((res) => {
      this.metaInfoMap = res;
    });
    this.subscriptions.push(metaInfoSub);
    const allQueriesSub = this.store
      .select(allQueries)
      .pipe(distinctUntilChanged())
      .subscribe((res: any) => {
        if (res) {
          try {
            this.queriesMap = { ...res };
            this.setQueryName();
          } catch (e) {
            console.error(e);
          }
        }
      });
    this.subscriptions.push(allQueriesSub);
    if (this.currentScreen) {
      if (this.currentScreen.pageType === 'list' && this.element.lookupTo !== 'defaultFilter') {
        this.isCurrentTableNeeded = false;
      }
    }
    const ctx = this.qbService?.qbContextTableInScreen ?? {};
    let tableIdForFields: string | undefined;
    if (this.element.lookupTo === 'defaultFilter') {
      tableIdForFields = this.qbService?.currentTableId;
    } else {
      tableIdForFields = ctx?.parentContextTableId || this.qbService?.currentTableId;
    }

    if (tableIdForFields) {
      const fieldInfoSub = this.baseService.get(ApiConstants.getFieldInfo, { tableId: tableIdForFields }).subscribe({
        next: (data: any) => {
          this.allFields = data;
        },
        error: (err) => {
          console.error(err);
        }
      });
      this.subscriptions.push(fieldInfoSub);
    }
    const appUserTableIds = Object.keys(this.tableIdMap).find((key) => this.tableIdMap[key] === 'Application User');
    if (appUserTableIds) {
      const appUserFieldInfoSub = this.baseService
        .get(ApiConstants.getFieldInfo, { tableId: appUserTableIds })
        .subscribe({
          next: (data: any) => {
            this.appUserFieldsInfo = data;
          },
          error: (err) => {
            console.error(err);
          }
        });
      this.subscriptions.push(appUserFieldInfoSub);
    }
    this.checkQueryExistence();
    this.updateCudConditionalVals();
  }

  checkQueryExistence() {
    this.store.dispatch(setQBQueries({ qbQueries: null }));
    this.store.dispatch(
      getQBQueries({
        apiConstants: ApiConstants.getQueriesListByTableId,
        params: { tableId: this.qbService.currentTableId }
      })
    );
    const showQueriesSub = this.store
      .select(qbQueries)
      .pipe(distinctUntilChanged())
      .subscribe((queries: any) => {
        if (queries?.length > 0) {
          this.isQueryExists = true;
        } else {
          this.isQueryExists = false;
        }
      });
    this.subscriptions.push(showQueriesSub);
  }

  handleChange(index) {
    if (index === 1 && this.isExist) {
      this.getReferences(this.qbObject.sid, this.usedIn);
    }
  }

  private mapUsedInToActionType(usedIn: string): ActionType {
    switch (usedIn) {
      case 'FIELD':
        return ActionType.QUERY_BUILDER_SOURCE_FIELD_REMOVE;
      case 'PAGE':
        return ActionType.QUERY_BUILDER_TARGET_FIELD_REMOVE;
      case 'RECORD':
      case 'WORKFLOW':
        return ActionType.QUERY_BUILDER_ROLE_REMOVE;
      case 'DEFAULT_FILTER':
        return ActionType.QUERY_BUILDER_FIELD_VALUE_REMOVE;
      default:
        return ActionType.QUERY_BUILDER_TARGET_FIELD_REMOVE;
    }
  }

  getReferences(queryId: string, type: string): void {
    this.showLoader = true;
    const actionType = this.mapUsedInToActionType(type);
    this.referenceUtil
      .getReferences({
        modelId: queryId,
        modelType: ModelType.QUERY_BUILDER,
        actionType,
        action: UiActions.DELETE
      })
      .then((references: any) => {
        this.processReferences(references || []);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.showLoader = false;
        try {
          this.cd.detectChanges();
        } catch {
          /* noop */
        }
      });
  }

  processReferences(references): void {
    this.references = [];
    if (!references) {
      this.cd.detectChanges();
      return;
    }
    if (references && references.length === 1) {
      if (this.isDatamodelField) {
        this.hasMoreReference =
          references[0].field === this.qbService.currentField && references[0].property !== this.element.name;
      }
    } else if (references && references.length > 1) {
      this.hasMoreReference = true;
    } else {
      this.hasMoreReference = false;
    }
    references.forEach((e) => {
      const obj: any = { ...e };
      if (this.isDatamodelField) {
        obj.name = this.getFieldName(e.field);
        obj.property = startCase(e.property);
      }
      if (this.isTableLevelAcl) {
        obj.role = this.getRoleName(e.role);
        obj.operation = startCase(e.operation);
      }
      if (this.isWorkflowAcl) {
        const actionInfo = this.findActonNode(this.element.details.workflowOrder, e.action);
        if (actionInfo) {
          this.getActorAndActionName(actionInfo, obj);
        }
      }
      if (this.isFromPage) {
        obj.elementName = startCase(e.elementName);
        obj.property = startCase(e.property);
      }
      this.references.push(obj);
    });
  }

  setBackup(data) {
    this.backup = { ...data };
  }

  togglePopup(rule: any, type: 'warning' | 'error') {
    if (this.activePopupRule === rule && this.popupType === type) {
      this.closePopup();
    } else {
      this.activePopupRule = rule;
      this.popupType = type;
    }
  }

  closePopup() {
    this.activePopupRule = null;
    this.popupType = null;
  }

  toggleRhsPopup(rule: any, type: 'warning' | 'error'): void {
    if (this.activeRhsPopupRule === rule && this.rhsPopupType === type) {
      this.closeRhsPopup();
    } else {
      this.activeRhsPopupRule = rule;
      this.rhsPopupType = type;
    }
  }

  closeRhsPopup(): void {
    this.activeRhsPopupRule = null;
    this.rhsPopupType = null;
  }

  isRhsOptionNoLonger(rule: any): boolean {
    if (!rule?.lhs?.fieldId || !rule?.rhs?.value) {
      return false;
    }

    const leftField = this.findFieldForRule(rule.lhs);
    if (!leftField || !this.isSelectionFieldType(leftField.f_type)) {
      return false;
    }

    return !this.valueExistsInFieldOptions(leftField, rule.rhs.value);
  }

  private findFieldForRule(lhs: { tableId: string; fieldId: string }): any {
    if (lhs.tableId?.includes('currentUser-')) {
      return this.appUserFieldsInfo?.find((f) => f.sid === lhs.fieldId.replace('currentUser-', ''));
    }
    return this.allFields?.find((f) => f.sid === lhs.fieldId);
  }

  private isSelectionFieldType(fieldType: string | undefined): boolean {
    if (!fieldType) {
      return false;
    }
    const selectionTypes = ['dropdown', 'checkbox', 'radio'];
    return selectionTypes.includes(fieldType.toLowerCase());
  }

  private valueExistsInFieldOptions(field: any, value: string): boolean {
    try {
      const options = typeof field.f_aValues === 'string' ? JSON.parse(field.f_aValues) : field.f_aValues;
      return options?.values?.some((opt: any) => opt.sid === value) ?? false;
    } catch {
      return true; // Return true (not "no longer") on parse error
    }
  }

  isRuleFieldIncompatibleType(rule: any): boolean {
    if (rule.lhs?.type) {
      return rule.lhs.type === 'image carousel' || rule.lhs.type === 'file attachments';
    }
    return false;
  }

  isRuleFieldNoLonger(rule: any): boolean {
    if (!rule.lhs?.fieldId || !rule.lhs?.tableId) {
      return false;
    }
    if (rule.lhs.fieldId.includes('_$_')) {
      return false;
    }
    if (this.isIncompatibleFieldType(rule.lhs.type)) {
      return true;
    }
    return this.checkFieldNoLongerExists(rule);
  }

  private isIncompatibleFieldType(type: string | undefined): boolean {
    return type === 'image carousel' || type === 'file attachments';
  }

  private checkFieldNoLongerExists(rule: any): boolean {
    const isCurrentUser = rule.lhs?.tableId?.includes('currentUser-');
    const fieldsArray = isCurrentUser ? this.appUserFieldsInfo : this.allFields;

    if (!fieldsArray?.length) {
      return false;
    }
    return this.util.isFieldNoLonger(rule, fieldsArray, 'qb-builder');
  }

  isRuleFieldMismatch(rule: any): boolean {
    if (!rule?.lhs?.tableId || !rule?.lhs?.fieldId) {
      return false;
    }

    if (rule?.rhs?.tableId && rule?.rhs?.fieldId) {
      return this.checkFieldToFieldMismatch(rule);
    }

    if (rule.rhs?.value) {
      return this.checkFieldToValueMismatch(rule);
    }

    return false;
  }

  private checkFieldToFieldMismatch(rule: any): boolean {
    const rightField = this.findFieldBySide(rule.rhs);
    if (!rightField) {
      return false;
    }

    const leftType = rule.lhs?.type?.toLowerCase() ?? '';
    if (!leftType || !GlobalConstants.paramMappDataTyp[leftType]) {
      return false;
    }

    return !GlobalConstants.paramMappDataTyp[leftType]?.includes(rightField.f_type.toLowerCase());
  }

  private checkFieldToValueMismatch(rule: any): boolean {
    if (rule.lhs.fieldId.includes('_$_')) {
      return false;
    }

    if (rule.fieldType === 'pageVariable') {
      return this.checkPageVariableMismatch(rule);
    }

    return this.isRuleMismatch(rule?.lhs, rule?.operator, rule?.rhs, rule.fieldType);
  }

  private checkPageVariableMismatch(rule: any): boolean {
    const fieldsArray = this.getFieldsArrayForTableId(rule.lhs?.tableId);
    if (!fieldsArray?.length) {
      return false;
    }
    return this.util.isFieldMismatch(rule, fieldsArray, this.pageVariables, 'qb-builder');
  }

  private findFieldBySide(side: { tableId: string; fieldId: string }): any {
    if (!side?.tableId || !side?.fieldId) {
      return null;
    }
    const isCurrentUser = side.tableId.includes('currentUser-');
    const fieldsArray = isCurrentUser ? this.appUserFieldsInfo : this.allFields;
    const fieldId = isCurrentUser ? side.fieldId.replace('currentUser-', '') : side.fieldId;
    return fieldsArray?.find((f) => f.sid === fieldId);
  }

  private getFieldsArrayForTableId(tableId: string): any[] {
    if (tableId?.includes('currentUser-')) {
      return this.appUserFieldsInfo;
    }
    return this.allFields;
  }

  isRuleMismatch(lhs: any, operator: string, rhs: any, fieldType: string): boolean {
    const leftType = this.resolveLeftType(lhs);
    if (!leftType || this.isTypeExemptFromMismatch(leftType)) {
      return false;
    }

    const rightType = rhs ? this.util.determineRightType(rhs, fieldType) : '';
    if (!rightType) {
      return false;
    }

    if (this.areTypesCompatible(leftType, rightType)) {
      return false;
    }

    if (!GlobalConstants.paramMappDataTyp[leftType]) {
      return false;
    }

    return !GlobalConstants.paramMappDataTyp[leftType]?.includes(rightType);
  }

  private resolveLeftType(lhs: any): string | undefined {
    if (lhs?.type) {
      return lhs.type.toLowerCase();
    }
    const leftField = this.findFieldBySide(lhs);
    return leftField?.f_type?.toLowerCase();
  }

  private isTypeExemptFromMismatch(type: string): boolean {
    const exemptTypes = [
      'dropdown', 'checkbox', 'radio', 'text', 'url', 'color',
      'category', 'role', 'image carousel', 'file attachments'
    ];
    return exemptTypes.includes(type);
  }

  private areTypesCompatible(leftType: string, rightType: string): boolean {
    const compatibilityRules: [string, string][] = [
      ['double', 'number'],
      ['time', 'datetime'],
      ['string', 'email']
    ];

    for (const [left, right] of compatibilityRules) {
      if (leftType === left && rightType === right) {
        return true;
      }
    }

    if (rightType === 'customTime' && (leftType === 'date' || leftType === 'time')) {
      return true;
    }

    return false;
  }

  getQueryObject() {
    try {
      if (!this.qbObject || (!this.qbObject?.sid && !this.qbObject?.queryName)) {
        this.showLoader = false;
        this.query = '';
        return;
      }
      let appId = this.element?.refAppId ? this.element?.refAppId : this.appGlobalService.get('appId');
      const qbObjSub = this.baseService
        .get(ApiConstants.getQueryByAppId, { sid: this.qbObject.sid, appId: appId })
        .subscribe({
          next: (data: any) => {
            this.showLoader = false;
            this.setBackup(data);
            this.isExist = true;
            this.qbObject = data;
            this.qbName = data.queryName;
            this.description = data.queryDescription;
            this.qbObject.query = JSON.parse(data.query);
            if (data.query?.rules) {
              this.processQueryRulesValidation(data.query.rules);
            }
            this.query = this.processRulesForQB(this.qbObject.query);

            //  this.processReferences(data['references']);
          },
          error: (err: any) => {
            this.createInitalObject();
            this.showLoader = false;
          }
        });
      this.subscriptions.push(qbObjSub);
    } catch (e) {
      console.error(e);
    }
  }

  getNoLongerMessage(safeFields, translation) {
    if (safeFields) {
      this.fieldswarning = translation.replace('{fields}', safeFields);
    }
  }

  private processQueryRulesValidation(rules: any[]): void {
    const deletedIds: string[] = [];

    rules.forEach((rule) => {
      if (rule.lhs?.fieldId?.includes('_$_')) {
        return;
      }

      const leftField = this.findLeftFieldForRule(rule);
      const deletedFieldId = this.getDeletedFieldId(rule, leftField);

      if (deletedFieldId) {
        deletedIds.push(deletedFieldId);
      }

      this.checkPageVariableTypeMismatch(rule, leftField);
    });

    this.handleDeletedFieldsWarning(deletedIds);
    this.handleTypeMismatchWarning();
  }

  private findLeftFieldForRule(rule: any): any {
    const isCurrentUser = rule.lhs?.tableId?.includes('currentUser-');
    const fieldsArray = isCurrentUser ? this.appUserFieldsInfo : this.allFields;
    const fieldId = isCurrentUser
      ? rule.lhs?.fieldId?.replace('currentUser-', '')
      : rule.lhs?.fieldId;

    return fieldsArray?.find((f) => f.sid === fieldId);
  }

  private getDeletedFieldId(rule: any, leftField: any): string | null {
    if (leftField) {
      return null;
    }

    const isCurrentUser = rule.lhs?.tableId?.includes('currentUser-');
    const fieldsArray = isCurrentUser ? this.appUserFieldsInfo : this.allFields;

    if (!fieldsArray?.length) {
      return null;
    }

    return isCurrentUser
      ? rule.lhs?.fieldId?.replace('currentUser-', '')
      : rule.lhs?.fieldId;
  }

  private checkPageVariableTypeMismatch(rule: any, leftField: any): void {
    if (rule.fieldType !== 'pageVariable' || !leftField) {
      return;
    }

    const rightField = this.pageVariables.find((f) => f.value === rule.rhs?.value);
    if (!rightField) {
      return;
    }

    const leftType = leftField.f_type?.toLowerCase();
    const rightType = this.util.normalizePageVariableType(rightField.type?.toLowerCase());

    if (!GlobalConstants.paramMappDataTyp[leftType]?.includes(rightType)) {
      this.leftFields += leftField.name + ',';
      this.rightFields += rightField.name + ',';
    }
  }

  private handleDeletedFieldsWarning(deletedIds: string[]): void {
    if (deletedIds.length === 0) {
      return;
    }

    const translation = this.translate.instant('NO_LONGER_FIELDS_IN_QBUILDER') || '';
    this.getNoLongerMessage('', translation);
    this.util.handleDeletedIds(deletedIds, false, '', true, 'querybuilder');
  }

  private handleTypeMismatchWarning(): void {
    if (!this.leftFields || !this.rightFields) {
      return;
    }

    this.fieldMismatchWarning = this.translate
      .instant('PARAM_QB_FLD_TYP')
      .replace('{field1}', this.leftFields.slice(0, -1))
      .replace('{field2}', this.rightFields.slice(0, -1));

    this.leftFields = '';
    this.rightFields = '';

    this.confirmationDialogService.confirm({
      message: this.fieldMismatchWarning,
      acceptLabel: this.translate.instant('OK'),
      accept: () => { /* empty */ },
      rejectVisible: false
    });
  }

  setValueToQueryBuilder(value) {
    if (value) {
      try {
        this.qbObject = JSON.parse(value);
      } catch (e) {
        // value can be sid or an object
        this.qbObject = { sid: value };
      }
      this.setQueryName();
      this.query = null;
    } else {
      this.createInitalObject();
    }
  }

  createInitalObject() {
    this.isExist = false;
    this.backup = {
      tableId: this.qbService.currentTableId,
      appId: this.appGlobalService.get(GlobalConstants.appIdParam),
      orgId: this.appGlobalService.get('orgId')
    };
    this.qbObject = null;
    this.qbName = null;
    this.query = null;
  }

  onCloseQb() {
    this.loader.hide();
    //this.showQueryBuilder = false;
    this.showQueries = false;
    this.showLoader = false;
  }

  sortKeys = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(this.sortKeys);
    } else if (obj !== null && typeof obj === 'object') {
      return Object.keys(obj)
        .sort((a, b) => a.localeCompare(b))
        .reduce((acc, key) => {
          acc[key] = this.sortKeys(obj[key]);
          return acc;
        }, {});
    }
    return obj;
  };

  deepEqual(a, b) {
    return JSON.stringify(this.sortKeys(a)) === JSON.stringify(this.sortKeys(b));
  }

  cleanQueryForComparison(query: any): void {
    if (query && query.rules && Array.isArray(query.rules)) {
      query.rules.forEach((rule) => {
        delete rule.field;
        delete rule.entity;
        if (rule.rhs && Object.keys(rule.rhs).length === 0) {
          delete rule.rhs;
        }
        if (!this.isDefaultFilter) {
          delete rule?.allowEdit;
          delete rule?.allowView;
          delete rule?.holdValue;
        }
        if (rule.rules) {
          this.cleanQueryForComparison(rule);
        }
      });
    }
  }

  isQueryDirty(): boolean {
    // Compare the current query with the backup (original) query
    if (!this.showQueryBuilder) {
      return false;
    } // Not open, not dirty
    if (!this.query) {
      return false;
    }
    if (this.backup.query === undefined) {
      if ((!Array.isArray(this.query.rules) || this.query.rules.length === 0) && !this.qbName && !this.description) {
        return false;
      }
      return true;
    }
    const query1 = JSON.parse(this.backup.query);
    const query2 = JSON.parse(JSON.stringify(this.query));

    this.cleanQueryForComparison(query1);
    this.cleanQueryForComparison(query2);

    const isQueryChanged = !this.deepEqual(query1, query2);
    const nameChanged = (this.qbName ?? '') !== (this.backup.queryName ?? '');
    const descChanged = (this.description ?? '') !== (this.backup.queryDescription ?? '');
    return isQueryChanged || nameChanged || descChanged;
  }

  confirmCancel(event?: any) {
    this.onCancel.emit(true);
    if (this.showQueryBuilder && this.isQueryDirty()) {
      this.confirmationDialogService.confirm({
        message: this.translate.instant('UNSAVED_CHANGES_CONFIRM'),
        header: 'Confirmation',
        accept: () => {
          this.toggleQueryBuilder(event);
        },
        reject: () => {
          // empty
        }
      });
    } else {
      // If there are no saved changes, and no query exists revert value to ALWAYS in workflow tree
      if (this.isWorkflowAcl && (!Array.isArray(this.query.rules) || this.query.rules?.length === 0)) {
        this.revert.emit();
      }
      this.showQueryBuilder = false;
      this.description = null;
    }
  }

  toggleQueryBuilder(event?: any) {
    if (this.element?.lookupTo === 'defaultFilter') {
      this.allowRuleset = false;
      this.isDefaultFilter = true;
      this.fieldTypes = [
        { name: 'Value', value: 'value' },
        { name: 'Page Variables', value: 'pageVariable' }
      ];
      this.datefieldTypes = [
        { name: 'Value', value: 'value' },
        { name: 'Custom', value: 'custom' },
        { name: 'Page Variables', value: 'pageVariable' },
        { name: '+ days', value: 'plusDays' },
        { name: '- days', value: 'minusDays' }
      ];
      this.rangeFieldTypes = [
        { name: 'Values', value: 'values' },
        { name: 'Custom', value: 'custom' },
        { name: 'Page Variables', value: 'pageVariable' },
        { name: '+ days', value: 'plusDays' },
        { name: '- days', value: 'minusDays' }
      ];
      this.updateCudConditionalVals();
    }
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      this.getQueryObject();
      // Configure query builder based on current context (ACL vs default) for Pages only
      if (this.currentScreen) {
        this.configureQueryBuilderContext();
      }
      if (this.element.lookupTo === 'defaultFilter') {
        this.qbService.configureQBFields({
          roleNeeded: false,
          isAppUserNeeded: false,
          isCurrentTableNeeded: this.isCurrentTableNeeded,
          isDefaultFilter: this.isDefaultFilter,
          currScr: this.currentScreen
        });
      } else {
        this.qbService.configureQBFields({
          roleNeeded: true,
          isAppUserNeeded: true,
          isCurrentTableNeeded: this.isCurrentTableNeeded,
          isDefaultFilter: this.isDefaultFilter
        });
      }
      this.store.dispatch(getAllQueries({ apiConstants: ApiConstants.getAllQueriesByAppId }));
      this.pagename = this.currentScreen?.pageName;
    }
    if (this.element.lookupTo == 'ConditionalFieldTab') {
      this.store.dispatch(getAllQueries({ apiConstants: ApiConstants.getAllQueriesByAppId }));
    }
    if (event == undefined && this.element.lookupTo == 'ACL') {
      this.onSave.emit(null);
    }
    this.workflowname = this.workflowName;
    this.queryBuilderPropertyName = this.element.name;
    this.zone.run(() => {
      this.message = {};
      this.showQueryBuilder = !this.showQueryBuilder;
    });
    if (this.showQueryBuilder) {
      const qbSub = this.qbProperties$.subscribe((qbProperties) => {
        if (qbProperties) {
          this.config = cloneDeep(qbProperties);
          if (
            this.element.lookupTo == 'List of Fields' ||
            this.element.lookupTo == 'ACL' ||
            this.element.lookupTo == 'CUD'
          ) {
            this.config.addRule = this.addRule.bind(this);
            this.config.addRuleSet = this.addRuleSet.bind(this);
            this.config.getInputType = this.getInputType.bind(this);
            if (this.qbObject?.query) {
              this.query = this.processRulesForQB(this.qbObject?.query);
            }
            this.cd.detectChanges();
          } else if (this.element.lookupTo === 'List of Fields and Roles') {
            if (this.allRoles) {
              this.formRolesQueryBuilderProperties(this.allRoles);
            }
          } else if (this.element.lookupTo === 'defaultFilter') {
            this.config.addRule = this.addRule.bind(this);
            this.config.getInputType = this.getInputType.bind(this);
            if (this.qbObject?.query) {
              this.query = this.processRulesForQB(this.qbObject?.query);
            }
            if (!this.qbObject || (!this.qbObject?.sid && !this.qbObject?.queryName)) {
              let field: any = {};
              let err = false;
              let msg = '';
              if (this.techStack?.textSearch == GlobalConstants.searchDbEs) {
                field = Object.values(this.config.fields).find((value: any) => value.searchable) || null;
              } else {
                field = Object.values(this.config.fields)[0];
              }

              if (!field) {
                field = Object.values(this.config.fields)[0];
                err = true;
                msg = this.translate.instant('DEFFIL_FLD_SEARCH').replace('{field}', field.name);
              }
              this.query = {
                condition: 'and',
                rules: [
                  {
                    field: field.value ? field.value : field.sid,
                    operator: Operators.ISEQUAL,
                    value: '',
                    entity: field.entity,
                    fieldType: 'value',
                    lhs: {
                      type: field.type
                    },
                    rhs: {},
                    sid: uuidv4(),
                    allowView: false,
                    allowEdit: false,
                    holdValue: false,
                    err: err,
                    msg: msg
                  }
                ]
              };
              // this.query = this.processRulesForQB(this.query);
            }
          }
          if (qbSub) {
            qbSub.unsubscribe();
          }
        }
      });
      this.subscriptions.push(qbSub);
    } else {
      if (this.backup) {
        this.qbName = this.backup.queryName;
      }
      this.message = {};
    }
  }

  /**
   * Determines the effective table context (ACL parent vs current) and configures the query builder.
   * Priority: If element is ACL and parentContextTableId exists, use it; otherwise fall back to currentContextTableId.
   */
  private configureQueryBuilderContext(): void {
    const ctx = (this.qbService.qbContextTableInScreen ?? {}) as {
      parentContextTableId?: string;
      currentContextTableId?: string;
    };
    const tableIdMap = (this.qbService.tableIdMap ?? {}) as Record<string, string>;

    // Use parent context table only for ACL when available; otherwise fall back to current context
    const isAcl = (this.element as any)?.lookupTo === 'ACL';
    const contextTableId = isAcl && ctx.parentContextTableId ? ctx.parentContextTableId : ctx.currentContextTableId;
    const tableName = contextTableId ? (tableIdMap[contextTableId] ?? '') : '';
    this.currentTableName = tableName;
    this.qbService.configureQueryBuilder(this.qbService.appUserTableId, contextTableId, tableName);
  }

  formRolesQueryBuilderProperties(allRoles) {
    allRoles.forEach((e) => {
      const obj = { name: $.ui.fancytree.unescapeHtml(e.name), type: 'string', nullable: true };
      this.config.fields[e.name] = obj;
    });
  }

  updateAllQueries(obj) {
    if (obj.queryName === this.backup.queryName) {
      return;
    }
    this.queriesMap[obj.sid] = obj.queryName;
    this.store.dispatch(setAllQueries({ allQueries: this.queriesMap }));
  }

  UpdateRule(event) {
    if (!this.allowView) {
      this.allowEdit = false;
    }
    this.selectedRule = {
      ...this.selectedRule,
      ...{
        allowEdit: this.allowEdit,
        allowView: this.allowView,
        holdValue: this.holdValue
      }
    };
    /*
      Disable the hold filter immediately for the formula fields once it is set to false
    */
    const fld: any = Object.values(this.config.fields)?.find((f: any) => f.sid === this.selectedRule?.field);
    if (fld.sysGen || fld.f_formula) {
      this.holdValDis = true;
    }
    const rules = this.query?.rules?.map((r) => {
      return r?.field && r?.field === this.selectedRule?.field ? this.selectedRule : r;
    });
    this.query = { ...this.query, ...{ rules: rules } };
  }

  setValueToForm(value) {
    const obj = this.buildQueryObject(value);
    const isNewQuery = !this.isExist && !this.selectedQuery;
    const apiConstants = this.getApiConstants(isNewQuery);

    if (this.createAsNew) {
      this.handleCreateAsNew(apiConstants, obj, value);
      return;
    }

    if (this.isExist && !this.util.isEqualIgnoreCase(this.backup, obj, [])) {
      this.handleExistingQueryUpdate(apiConstants, obj, value);
      return;
    }

    if (this.isExist && this.util.isEqualIgnoreCase(this.backup, obj, [])) {
      this.handleNoChanges();
      return;
    }

    if (!this.selectedQuery && this.isExist) {
      this.showMessage('warn', 'No changes to save.');
      return;
    }

    this.saveData(apiConstants, obj, value);
  }

  private buildQueryObject(value: any): any {
    const obj = { ...this.backup };
    obj.queryName = this.qbName;
    obj.query = JSON.stringify(value);
    obj.queryDescription = this.description;
    obj.sid = this.qbObject?.sid ? this.qbObject?.sid : uuidv4();
    obj.usedIn = this.isDefaultFilter ? 'DEFAULT_FILTER' : this.usedIn;
    return obj;
  }

  private getApiConstants(isNewQuery: boolean): any {
    return !isNewQuery ? ApiConstants.updateQuery : ApiConstants.saveQuery;
  }

  private handleCreateAsNew(apiConstants: any, obj: any, value: any): void {
    const saveApiConstants = ApiConstants.saveQuery;
    obj.sid = uuidv4();

    if (obj.queryName === this.backup.queryName) {
      this.showMessage('error', 'Please change the query name before save');
      return;
    }

    this.saveData(saveApiConstants, obj, value);
  }

  private handleExistingQueryUpdate(apiConstants: any, obj: any, value: any): void {
    if (this.isDefaultFilter) {
      this.saveData(apiConstants, obj, value);
      return;
    }

    if (this.rulesCopied) {
      this.handleRulesCopiedSave(obj);
      return;
    }

    this.showUpdateConfirmation(apiConstants, obj, value);
  }

  private handleRulesCopiedSave(obj: any): void {
    this.updateAllQueries(obj);
    let objToSave: any = { sid: this.qbObject.sid };

    if (this.isDefaultFilter) {
      objToSave = { ...objToSave, query: obj.query };
    }

    if (this.isCudConditional) {
      objToSave['ruleCopied'] = true;
    }

    this.setBackup(this.selectedQuery);
    this.showLoader = true;
    this.cd.detectChanges();

    this.onSave.emit(objToSave);
    this.set(JSON.stringify(objToSave));
    this.showQueryBuilder = false;
    this.description = null;
    this.showLoader = false;
  }

  private showUpdateConfirmation(apiConstants: any, obj: any, value: any): void {
    this.confirmationDialogService.confirm({
      message: `Changes in the query will reflect in all the places where it is used. Do you want to change the query?`,
      accept: () => {
        this.saveData(apiConstants, obj, value);
      },
      reject: () => {
        /* empty */
      }
    });
  }

  private handleNoChanges(): void {
    this.showMessage('warn', 'No changes to save.');
    this.showLoader = false;
    this.cd.detectChanges();
  }

  getAdditionalPath() {
    let path;
    switch (this.element.name) {
      case 'f_editC':
      case 'f_viewC':
      case 'f_cMandatory':
        path = `${this.formData?.['f_tableId']}`;
        break;
      case 'conditionForButtonEnable':
      case 'conditionForButtonVisiblity':
        path = `${this.formData?.['currentNode']}`;
        break;
      default:
        break;
    }
    return path;
  }

  formReferences(ref, data, obj, action, dataWithOrigin?) {
    if (!data) {
      return ref;
    }

    const isCreate = action === 'create';
    const appId = this.appGlobalService.get('appId');

    // Helper to get the referredAppId for a field
    const getFieldAppId = (fld, originObj?) => {
      // Check if it's a currentUser (Application User) field based on origin side
      const rule = originObj?.rule;
      const origin = originObj?.origin;
      let isCurrentUserField = false;
      if (origin === 'lhs') {
        isCurrentUserField =
          rule?.lhs?.tableId?.includes('currentUser-') || rule?.lhs?.fieldId?.includes('currentUser-');
      } else if (origin === 'rhs') {
        isCurrentUserField =
          rule?.rhs?.tableId?.includes('currentUser-') || rule?.rhs?.fieldId?.includes('currentUser-');
      }

      if (isCurrentUserField && this.qbService.appUserAppId) {
        // Use appUserAppId stored in service when appUserFields were processed
        return this.qbService.appUserAppId;
      }

      // Fallback to qbService.currentRefAppId or current appId
      return this.qbService.currentRefAppId || appId;
    };

    // Helper to determine field reference metadata
    const getFieldReferenceMetadata = (fld, isDelete = false) => {
      let pageVarId;
      let originObjField = dataWithOrigin?.find((item) => item.fieldId === fld);
      let isRhs = originObjField?.origin === 'rhs';
      let sourcePropertyName = this.isDefaultFilter
        ? utilEnum.propertyName.DEFAULT_FILTER_SOURCE_FIELD
        : utilEnum.propertyName.RULE_SOURCE_FIELD;

      // For delete, use old value from originObjField if available
      if (isDelete && originObjField && originObjField.rule?.fieldType === 'pageVariable') {
        pageVarId = originObjField.rule?.rhs?.value;
      } else {
        pageVarId = this.isPageVariable(obj, fld);
      }

      if (pageVarId) {
        return [
          {
            refModelType: utilEnum.modelType.FIELD,
            propertyName: sourcePropertyName,
            refModelId: fld,
            sourceFieldId: null,
            manualChange: true
          },
          {
            refModelType: utilEnum.modelType.PAGE_VARIABLE,
            propertyName: utilEnum.propertyName.DEFAULT_FILTER_PAGE_VARIABLE,
            refModelId: pageVarId,
            sourceFieldId: fld,
            manualChange: false
          }
        ];
      }

      const propertyName = isRhs ? utilEnum.propertyName.RULE_TARGET_FIELD : sourcePropertyName;
      const sourceFieldId = isRhs && originObjField?.lhsFieldId ? originObjField.lhsFieldId : null;

      return [
        {
          refModelType: utilEnum.modelType.FIELD,
          propertyName,
          refModelId: fld,
          sourceFieldId,
          manualChange: propertyName === sourcePropertyName
        }
      ];
    };

    // Process fields
    if (data.fields) {
      data.fields.forEach((fld) => {
        const metadataList = getFieldReferenceMetadata(fld, !isCreate);
        const originObjField = dataWithOrigin?.find((item) => item.fieldId === fld);
        const fieldAppId = getFieldAppId(fld, originObjField);

        metadataList.forEach((metadata) => {
          const adInfo = metadata.sourceFieldId ? { sourceFieldId: metadata.sourceFieldId } : null;

          if (isCreate) {
            ref.push(
              this.util.createReference(
                obj.sid,
                utilEnum.modelType.QUERY_BUILDER,
                metadata.refModelId,
                metadata.refModelType,
                fieldAppId,
                null,
                metadata.propertyName,
                metadata.manualChange,
                adInfo,
                metadata.sourceFieldId
              )
            );
          } else {
            ref.push(
              this.util.createObjForDelRef(
                obj.sid,
                metadata.refModelId,
                metadata.propertyName,
                adInfo,
                metadata.sourceFieldId,
                fieldAppId
              )
            );
          }
        });
      });
    }

    // Process roles
    if (data.roles) {
      const lhsRoleEntries = (dataWithOrigin || []).filter(
        (e) => e.origin === 'lhs' && e.rule?.lhs?.type === 'role' && Array.isArray(e.rule?.rhs?.value)
      );
      data.roles.forEach((roleId) => {
        const producingRule = lhsRoleEntries.find((entry) => entry.rule.rhs.value.includes(roleId));
        const sourceFieldId = producingRule?.fieldId || null;
        const adInfo = sourceFieldId ? { sourceFieldId } : null;

        if (isCreate) {
          ref.push(
            this.util.createReference(
              obj.sid,
              utilEnum.modelType.QUERY_BUILDER,
              roleId,
              utilEnum.modelType.ROLE,
              this.allRoles[0]?.appId,
              null,
              utilEnum.propertyName.RULE_TARGET_FIELD,
              true,
              adInfo,
              sourceFieldId
            )
          );
        } else {
          ref.push(
            this.util.createObjForDelRef(
              obj.sid,
              roleId,
              utilEnum.propertyName.RULE_TARGET_FIELD,
              adInfo,
              sourceFieldId
            )
          );
        }
      });
    }

    // Process allowed values
    if (data.allowedVals) {
      const lhsCategoryEntries = (dataWithOrigin || []).filter(
        (e) => e.origin === 'lhs' && e.rule?.lhs?.type === 'category' && e.rule?.rhs?.value
      );
      data.allowedVals.forEach((valId) => {
        const producingRule = lhsCategoryEntries.find((entry) => {
          const v = entry.rule.rhs.value;
          return Array.isArray(v) ? v.includes(valId) : v === valId;
        });
        const sourceFieldId = producingRule?.fieldId || null;
        const adInfo = sourceFieldId ? { sourceFieldId } : null;

        if (isCreate) {
          ref.push(
            this.util.createReference(
              obj.sid,
              utilEnum.modelType.QUERY_BUILDER,
              valId,
              utilEnum.modelType.FIELD_VALUE,
              appId,
              null,
              utilEnum.propertyName.RULE_FIELD_VALUE,
              true,
              adInfo,
              sourceFieldId
            )
          );
        } else {
          ref.push(
            this.util.createObjForDelRef(obj.sid, valId, utilEnum.propertyName.RULE_FIELD_VALUE, adInfo, sourceFieldId)
          );
        }
      });
    }

    // Process fieldType changes (when LHS field stays same but RHS changes - page variable or field)
    if (data.fieldType && data.fieldType.length) {
      data.fieldType.forEach((ftEntry) => {
        if (ftEntry.rhsVal && ftEntry.lhsVal) {
          const lhsFieldId = ftEntry.lhsVal.includes('currentUser-')
            ? ftEntry.lhsVal.substring(12)
            : ftEntry.lhsVal;

          // Handle page variable changes
          if (ftEntry.fieldType === 'pageVariable') {
            const pageVarId = ftEntry.rhsVal;

            if (isCreate) {
              // Add page variable reference
              ref.push(
                this.util.createReference(
                  obj.sid,
                  utilEnum.modelType.QUERY_BUILDER,
                  pageVarId,
                  utilEnum.modelType.PAGE_VARIABLE,
                  appId,
                  null,
                  utilEnum.propertyName.DEFAULT_FILTER_PAGE_VARIABLE,
                  false,
                  { sourceFieldId: lhsFieldId },
                  lhsFieldId
                )
              );
            } else {
              // Delete page variable reference
              ref.push(
                this.util.createObjForDelRef(
                  obj.sid,
                  pageVarId,
                  utilEnum.propertyName.DEFAULT_FILTER_PAGE_VARIABLE,
                  { sourceFieldId: lhsFieldId },
                  lhsFieldId
                )
              );
            }
          }

          // Handle RHS field changes (when fieldType is 'field')
          if (ftEntry.fieldType === 'field') {
            const rhsFieldId = ftEntry.rhsVal.includes('currentUser-')
              ? ftEntry.rhsVal.substring(12)
              : ftEntry.rhsVal;

            if (isCreate) {
              // Add field reference for RHS field
              ref.push(
                this.util.createReference(
                  obj.sid,
                  utilEnum.modelType.QUERY_BUILDER,
                  rhsFieldId,
                  utilEnum.modelType.FIELD,
                  appId,
                  null,
                  utilEnum.propertyName.RULE_TARGET_FIELD,
                  false,
                  { sourceFieldId: lhsFieldId },
                  lhsFieldId
                )
              );
            } else {
              // Delete field reference for RHS field
              ref.push(
                this.util.createObjForDelRef(
                  obj.sid,
                  rhsFieldId,
                  utilEnum.propertyName.RULE_TARGET_FIELD,
                  { sourceFieldId: lhsFieldId },
                  lhsFieldId
                )
              );
            }
          }
        }
      });
    }

    return ref;
  }

  isPageVariable(obj, fld): string | null {
    const extractPageVarId = (rulesArr: any[]): string | null => {
      for (const r of rulesArr) {
        if (r && Array.isArray(r.rules)) {
          const nested = extractPageVarId(r.rules);
          if (nested) {
            return nested;
          }
        } else if (
          r?.fieldType === 'pageVariable' &&
          r?.lhs?.fieldId === fld &&
          r?.rhs &&
          typeof r.rhs.value === 'string'
        ) {
          return r.rhs.value;
        }
      }
      return null;
    };
    try {
      const rulesRoot = JSON.parse(obj?.query)?.rules || [];
      return extractPageVarId(rulesRoot);
    } catch {
      return null;
    }
  }

  getRolesAndFlds(flds, roles, allowedVals, val, fieldType, fieldsWithOrigin: any = []) {
    val.rules.forEach((rule) => {
      if (rule.lhs || rule.rhs) {
        if (rule.lhs && rule.lhs.fieldId && !flds.find((fld) => fld === rule.lhs.fieldId)) {
          const lid = rule.lhs.fieldId.includes('currentUser-') ? rule.lhs.fieldId.substring(12) : rule.lhs.fieldId;
          flds = [...flds, lid];
          fieldsWithOrigin = [...fieldsWithOrigin, { fieldId: lid, origin: 'lhs', rule }];
        }
        if (rule.rhs && rule.rhs.fieldId && !flds.find((fld) => fld === rule.rhs.fieldId)) {
          const rid = rule.rhs.fieldId.includes('currentUser-') ? rule.rhs.fieldId.substring(12) : rule.rhs.fieldId;
          flds = [...flds, rid];
          const lhsFieldId = rule.lhs?.fieldId?.includes('currentUser-')
            ? rule.lhs.fieldId.substring(12)
            : rule.lhs?.fieldId;
          fieldsWithOrigin = [...fieldsWithOrigin, { fieldId: rid, origin: 'rhs', lhsFieldId, rule }];
        }
        if (rule?.fieldType) {
          // For 'field' type, use rhs.fieldId; for others (like pageVariable), use rhs.value
          const rhsVal = rule?.fieldType === 'field' ? rule?.rhs?.fieldId : rule?.rhs?.value;
          fieldType = [
            ...fieldType,
            { fieldType: rule?.fieldType, rhsVal: rhsVal, lhsVal: rule?.lhs?.fieldId }
          ];
        }
        if (rule.lhs && rule.rhs) {
          if (rule.lhs.type === 'category' && rule.rhs.value) {
            if (Array.isArray(rule.rhs.value) && rule.rhs.value.length) {
              rule.rhs.value.forEach((aval) => {
                if (!allowedVals.includes(aval)) {
                  allowedVals = [...allowedVals, aval];
                }
              });
            } else if (!allowedVals.find((allowedValsid) => allowedValsid === rule.rhs.value)) {
              allowedVals = [...allowedVals, rule.rhs.value];
            }
          }
          if (rule.lhs.type === 'role' && rule.rhs.value && Array.isArray(rule.rhs.value) && rule.rhs.value.length) {
            rule.rhs.value.forEach((role) => {
              if (!roles.find((roleid) => roleid === role)) {
                roles = [...roles, role];
              }
            });
          }
        }
      }
      if (rule.rules) {
        const data = this.getRolesAndFlds(flds, roles, allowedVals, rule, fieldType, fieldsWithOrigin);
        flds = data.fields;
        roles = data.roles;
        allowedVals = data.allowedVals;
        fieldType = data.fieldType;
        fieldsWithOrigin = data.fieldsWithOrigin;
      }
    });
    return {
      fields: flds,
      roles: roles,
      allowedVals: allowedVals,
      fieldType: fieldType,
      fieldsWithOrigin: fieldsWithOrigin
    };
  }

  getOldAndNewFields(backup, latest, addedReference, deletedReference, obj) {
    const backupquery = JSON.parse(backup.query);
    const oldData = this.getRolesAndFlds([], [], [], backupquery, []);
    const newData = this.getRolesAndFlds([], [], [], latest, []);
    const dataTorem = { fields: [], roles: [], allowedVals: [], fieldType: [] },
      dataToSave = { fields: [], roles: [], allowedVals: [], fieldType: [] };

    const dataToSaveWithOrigin = newData.fieldsWithOrigin || [];
    const dataToRemoveWithOrigin = oldData.fieldsWithOrigin || [];

    if (oldData?.fields?.length || newData?.fields?.length) {
      dataTorem.fields = oldData?.fields?.filter((f) => !newData?.fields?.includes(f));
      dataToSave.fields = newData?.fields?.filter((f) => !oldData?.fields?.includes(f));
    }
    if (oldData?.roles?.length || newData?.roles?.length) {
      dataTorem.roles = oldData?.roles?.filter((f) => !newData?.roles?.includes(f));
      dataToSave.roles = newData?.roles?.filter((f) => !oldData?.roles?.includes(f));
    }
    if (oldData?.fieldType?.length || newData?.fieldType?.length) {
      // Identify references to delete when RHS changes (page variable or field)
      dataTorem.fieldType = oldData?.fieldType?.filter((f) => {
        // Find if the newData has a fieldType with same lhsVal but different rhsVal/type
        return newData?.fieldType?.find(
          (n) =>
            // Same fieldType (pageVariable or field) with same lhsVal but different rhsVal
            (n.lhsVal === f.lhsVal && n.fieldType === f.fieldType && (n.fieldType === 'pageVariable' || n.fieldType === 'field') && n.rhsVal !== f.rhsVal) ||
            // Different fieldType with same lhsVal
            (n.lhsVal === f.lhsVal && n.fieldType !== f.fieldType)
        );
      });
      // Identify references to add when RHS changes (page variable or field)
      dataToSave.fieldType = newData?.fieldType?.filter((f) => {
        return oldData?.fieldType?.find(
          (n) =>
            // Same fieldType (pageVariable or field) with same lhsVal but different rhsVal
            (n.lhsVal === f.lhsVal && n.fieldType === f.fieldType && (n.fieldType === 'pageVariable' || n.fieldType === 'field') && n.rhsVal !== f.rhsVal) ||
            // Different fieldType with same lhsVal
            (n.lhsVal === f.lhsVal && n.fieldType !== f.fieldType)
        );
      });
    }
    if (oldData?.allowedVals?.length || newData?.allowedVals?.length) {
      dataTorem.allowedVals = oldData?.allowedVals?.filter((f) => !newData?.allowedVals?.includes(f));
      dataToSave.allowedVals = newData?.allowedVals?.filter((f) => !oldData?.allowedVals?.includes(f));
    }
    addedReference = this.formReferences(addedReference, dataToSave, obj, 'create', dataToSaveWithOrigin);
    deletedReference = this.formReferences(deletedReference, dataTorem, obj, 'delete', dataToRemoveWithOrigin);
  }

  createReference(apiConstants, obj, val) {
    let addedReference: any[] = [],
      deletedReference: any[] = [];
    if (val.rules.length) {
      if (apiConstants.method === 'post') {
        const newData = this.getRolesAndFlds([], [], [], val, []);
        const dataToSaveWithOrigin = newData.fieldsWithOrigin || [];
        this.formReferences(addedReference, newData, obj, 'create', dataToSaveWithOrigin);
        if (this.isCudConditional) {
          const queryBuilderId = obj.sid;
          const tableAliasId = this.actionProp?.tableAliasId;
          const actionAliasId = this.actionProp?.sid;
          const qvName = 'CUDConditional';
          const qvAction = this.actionProp?.action || '';
          const tableAction = this.actionProp?.actionSequence || '';
          const refAppId = this.appGlobalService.get('appId');
          addedReference = addedReference.filter((ref) => ref?.type !== 'QUERYVIEW_CUD_CONFIGURATION');
          newData.fields.forEach((fld) => {
            // let actionRef = this.createCudActionReference(
            //   fld,
            //   queryBuilderId,
            //   tableAliasId,
            //   qvName,
            //   qvAction,
            //   tableAction,
            //   refAppId,
            //   actionAliasId
            // );
            // if (actionRef['additionalInfo'] && actionRef['additionalInfo']['path']) {
            //   delete actionRef['additionalInfo']['path'];
            // }
            // if (actionRef) addedReference.push(actionRef);
          });
        }
      } else if (apiConstants.method === 'put') {
        this.getOldAndNewFields(this.backup, val, addedReference, deletedReference, obj);
        if (this.isCudConditional) {
          const queryBuilderId = obj.sid;
          const tableAliasId = this.actionProp?.tableAliasId;
          const actionAliasId = this.actionProp?.sid;
          const qvName = 'CUDConditional';
          const qvAction = this.actionProp?.action || '';
          const tableAction = this.actionProp?.actionSequence || '';
          const refAppId = this.appGlobalService.get('appId');
          addedReference = addedReference.filter((ref) => ref?.type !== 'QUERYVIEW_CUD_CONFIGURATION');
          addedReference
            .filter((f) => f.referredModelType == 'FIELD')
            .forEach((fld) => {
              // let actionRef = this.createCudActionReference(
              //   fld.referredModelId,
              //   queryBuilderId,
              //   tableAliasId,
              //   qvName,
              //   qvAction,
              //   tableAction,
              //   refAppId,
              //   actionAliasId
              // );
              // if (actionRef['additionalInfo'] && actionRef['additionalInfo']['path']) {
              //   delete actionRef['additionalInfo']['path'];
              // }
              // if (actionRef) addedReference.push(actionRef);
            });
        }
      }
    }
    return {
      addedReference: addedReference.length ? addedReference : undefined,
      deletedReference: deletedReference.length ? deletedReference : undefined
    };
  }

  createCudActionReference(
    fieldId: any,
    queryBuilderId: string,
    tableAliasId: string,
    qvName: string,
    qvAction: string,
    tableAction: string,
    refAppId: string,
    actionAliasId?: string
  ) {
    const sid = `${this.appGlobalService.get(
      'appId'
    )}_${tableAliasId}_${refAppId}_${queryBuilderId}_${qvName}_${qvAction}_${tableAction}`;
    let ref = this.util.createReference(
      actionAliasId,
      'QUERYVIEW_CUD_CONFIGURATION', // referredModelType
      queryBuilderId, // sid
      'QUERY_BUILDER', // modelType
      this.appGlobalService.get('appId'), // appId
      { path: tableAliasId }, // additionalInfo
      'QUERYVIEW_CUD_CONFIGURATION', // propertyName (must be valid enum value)
      true, // manualChange
      this.actionProp // additionalInfo
    );
    ref.sid = sid; // Set the sid for the reference

    return ref;
  }

  saveData(apiConstants, obj, value) {
    if (obj.appId && this.element?.refAppId && this.appGlobalService.get('appId') !== this.element?.refAppId) {
      obj.appId = this.element?.refAppId;
    }
    if (this.appGlobalService?.isIndependentApp() === false) {
      obj.suiteAppId = this.appGlobalService.get('suiteId');
    }
    this.updateAllQueries(obj);
    this.showLoader = true;
    const refs = this.createReference(apiConstants, obj, value);
    const dataToSend = { ...{ queryBuilder: obj }, ...refs };
    const qbObjectSub = this.baseService[apiConstants?.method](apiConstants, dataToSend).subscribe(
      (qbObject: any) => {
        this.qbObject = { ...qbObject };
        this.setBackup(qbObject);
        this.qbObject.query = value;
        let objToSave = { sid: this.qbObject.sid };
        if (this.isDefaultFilter) {
          objToSave = { ...objToSave, ...{ query: obj.query } };
        }
        if (this.isCudConditional) {
          objToSave = { ...objToSave, ...{ refs: refs } };
        }
        this.onSave.emit(objToSave);
        this.set(JSON.stringify(objToSave));
        this.showLoader = false;
        this.showQueryBuilder = !this.showQueryBuilder;
        this.description = null;
        this.cd.detectChanges();
      },
      (err) => {
        this.showLoader = false;
        if (err.error.ERROR_CODE === 'ALREADY_EXISTS') {
          this.showMessage(
            'error',
            'Query with same name already exist for the selected table.Please change the query name and save again.'
          );
        }
      }
    );
    this.subscriptions.push(qbObjectSub);
  }

  saveQuery(newQuery: boolean) {
    this.hasInvalidRule = false;
    this.createAsNew = newQuery;
    this.loader.hide();
    this.message = {};
    if (!this.qbName) {
      this.message.qbName = 'Query name is mandatory';
      return;
    }
    if (this.query?.rules.length === 0) {
      this.showMessage('error', 'Atleast one rule is mandatory');
      return;
    }
    const query = this.processRulesForSave(this.query);
    if (this.hasInvalidRule) {
      return;
    }
    this.setValueToForm(query);
  }

  showMessage(status: string, message: string, detail?: string) {
    this.zone.run(() => {
      this.ms.clear();
      this.ms.add({
        life: 10000,
        severity: status,
        summary: message,
        detail: detail
      });
    });
  }

  onGroupChange(event, rule) {
    try {
      if (rule.lhs.entity && rule.lhs.entity !== event.value) {
        rule.lhs = {};
      }
      rule.rhs = {};
      if (event?.value) {
        const entity: any = this.qryBldrObj.entities.find(function (e) {
          return e.value === event.value;
        });
        const defaultField = this.qryBldrObj.getDefaultField(entity);
        rule.lhs.type = defaultField.type;
      } else {
        rule.field = null;
        this.onFieldCasadeChange({ value: null }, rule, []);
      }
    } catch (e) {
      console.error(e);
    }
  }

  changeFieldType(rule) {
    if (rule.fieldType === 'value' || rule.fieldType === 'pageVariable' || rule.fieldType === 'field') {
      rule.rhs = {};
      if (this.currentScreen?.pageType === 'list' && rule.fieldType === 'field') {
        this.showMessage(
          'warn',
          'Configuring queries with table fields in list page action buttons is not supported. Please use valid fields for the action.'
        );
      }
      if (rule.fieldType === 'pageVariable') {
        this.configureFieldTypeForPageVariable(rule);
      }
    } else {
      rule.rhs = {
        from: {},
        to: {}
      };
      if (rule.fieldType === 'values' && ['date', 'time'].includes(rule.lhs?.type)) {
        const fromValue = new Date().setHours(0, 0, 0, 0);
        const toValue = new Date().setHours(59, 59, 59, 59);
        rule.rhs.from.value = new Date(fromValue);
        rule.rhs.to.value = new Date(toValue);
      }
      if (rule.fieldType === 'custom') {
        rule.rhs = null;
      }
    }
  }

  onInputGroupChange(event, rule) {
    if (rule.fieldType === 'field') {
      rule.rhs = {};
      rule.rhs.tableId = event.value;
    } else {
      rule.rhs = {
        from: {},
        to: {}
      };
      rule.rhs.from.tableId = event.value;
    }
  }

  onToInputGroupChange(event, rule) {
    /* empty */
  }
  isOptionDisabled(option) {
    // Disable the option if it's not searchable and the tech stack is 'Elastic Search'
    return !option.searchable;
  }

  onFieldCasadeChange(event, rule, fields) {
    try {
      if (!rule.lhs) {
        rule.lhs = {};
      }
      if (event?.value) {
        rule.rhs = {};
        rule.err = false;
        rule.msg = '';
        const field = fields.filter((e) => e.sid === event.value);
        rule.lhs.type = field[0].type;
        if (rule.lhs.type === 'double') {
          rule.minFrac = field[0].f_minFrac;
          rule.maxFrac = field[0].f_maxFrac;
        }
        try {
          rule.operator = this.qryBldrObj.getDefaultOperator(field);
        } catch (e) {
          // getdefaultOperator may return error if there is no operator
          rule.operator = field[0]?.operators[0];
        }
        if (this.isDefaultFilter) {
          rule.fieldType =
            rule.operator === Operators.ISEMPTY || rule.operator === Operators.ISNOTEMPTY ? 'empty' : 'value';
          rule.allowEdit = false;
          rule.allowView = false;
          rule.holdValue = false;
        }
      } else {
        rule.field = null;
        rule.operator = '';
        rule.fieldType = '';
      }
    } catch (e) {
      console.log(e);
    }
  }

  onInputCasadeChange(event, rule) {
    if (!rule.rhs) {
      rule.rhs = {};
    }
  }

  captureValueChange($event, rule, field) {
    if (!rule.lhs) {
      rule.lhs = {};
    }
  }

  isStringOrArrayHasValue(value) {
    // return (typeof (value)==="string" && value.length > 0) || (isArray(value) && value.length > 0) || (value!==null && value!==undefined) || typeof (value)==="object";
    if (typeof value === 'string' && value.length > 0) {
      return true;
    } else if (Array.isArray(value)) {
      if (value.length > 0) {
        return true;
      }
      return false;
    } else if (
      value !== null &&
      value !== undefined &&
      ((typeof value === 'string' && value.trim() !== '') || typeof value !== 'string')
    ) {
      return true;
    } else if (typeof value === 'object') {
      if (value === null) {
        return false;
      }
      return true;
    }
    return false;
  }

  validPreviousRule(parent) {
    const ruleLength = parent.rules.length;
    if (ruleLength > 0) {
      const prevRule = parent.rules[ruleLength - 1];
      if (!this.validRule(prevRule)) {
        this.showMessage('error', this.translate.instant('RULE_MSG'));
        return false;
      }
      if (this.isDefaultFilter && !this.validDMRule(prevRule)) {
        return false;
      }
      if (!this.isDefaultFilter && !this.validateBetweenRule(prevRule)) {
        return false;
      }
      this.updateErrForRule(prevRule, false);
    }
    return true;
  }

  validDMRule(rule) {
    // validate whether the field is part of advance search
    let advSearchFlds: any = [];
    try {

      const screenData = JSON.parse(this.currentScreen?.contentAttachment);
      const advScrChilds = this.util.findNodeByKeyValue(screenData, 'type', 'tableSearch')?.children;

      if (advScrChilds) {
        advSearchFlds = advScrChilds.map((n) => n.key);
      }
    } catch (e) {
      console.error(e);
    }
    if (advSearchFlds.includes(rule?.field || rule.lhs.fieldId)) {
      this.updateErrForRule(rule, true);
      this.showMessage(
        'error',
        this.translate.instant('RULE_ADV_SEARCH').replace('{field}', this.config?.fields[rule.field]?.name)
      );
      return false;
    }
    // validate LHS to check for duplication
    if (this.query?.rules?.filter((r) => r?.field === rule?.field)?.length > 1) {
      this.updateErrForRule(rule, true);
      this.showMessage(
        'error',
        this.translate.instant('RULE_DUP_MSG').replace('{field}', this.config?.fields[rule.field]?.name)
      );
      return false;
    }
    // validate RHS based on datamodel
    const fld: any = Object.values(this.config.fields)?.find((f: any) => f.sid === (rule?.field || rule.lhs.fieldId));
    if (rule.fieldType === 'value') {
      if (rule.operator === Operators.ISEQUAL && rule?.lhs?.type !== 'date') {
        this.util.isvalidateDMProp(fld, fld?.f_type, rule?.rhs?.value, fld.name, true);
      }
    }
    if (rule.fieldType === 'values' && (rule.operator === Operators.ISBETWEEN || rule.operator === Operators.ISNOTBETWEEN)) {
      this.util.isvalidateDMProp(fld, fld?.f_type, rule?.rhs?.from?.value, fld.name, true);
      this.util.isvalidateDMProp(fld, fld?.f_type, rule?.rhs?.to?.value, fld.name, true);
      if (!this.validateBetweenValueOrder(rule, fld)) {
        return false;
      }
    }
    return true;
  }

  /**
   * Validates that the 'from' value is less than or equal to the 'to' value for "is between" rules.
   * Supports number, double, currency (numeric comparison) and date, time, datetime (date comparison).
   */
  private validateBetweenValueOrder(rule: any, fld: any): boolean {
    const fromVal = rule?.rhs?.from?.value;
    const toVal = rule?.rhs?.to?.value;
    if (fromVal == null || toVal == null) {
      return true;
    }
    const type = rule?.lhs?.type?.toLowerCase();
    let isInvalid = false;
    if (type === 'number' || type === 'double' || type === 'currency') {
      isInvalid = Number(fromVal) > Number(toVal);
    } else if (type === 'date' || type === 'time' || type === 'datetime') {
      isInvalid = new Date(fromVal).getTime() > new Date(toVal).getTime();
    }
    if (isInvalid) {
      this.updateErrForRule(rule, true);
      this.showMessage(
        'error',
        this.translate.instant('RULE_BETWEEN_ORDER_MSG')?.replace('{field}', fld?.name)
      );
      return false;
    }
    return true;
  }

  /**
   * Validates between value order for non-default-filter queries.
   */
  private validateBetweenRule(rule: any): boolean {
    if (rule.fieldType === 'values' && (rule.operator === Operators.ISBETWEEN || rule.operator === Operators.ISNOTBETWEEN)) {
      const fld: any = Object.values(this.config.fields)?.find((f: any) => f.sid === (rule?.field || rule.lhs?.fieldId));
      if (fld && !this.validateBetweenValueOrder(rule, fld)) {
        return false;
      }
    }
    return true;
  }

  private readonly fieldTypeValidators: Record<string, (rule: any) => boolean> = {
    value: (rule) => this.validateValueFieldType(rule),
    values: (rule) => this.validateValuesFieldType(rule),
    pageVariable: (rule) => Object.keys(rule.rhs).length !== 0,
    plusDays: (rule) => !!rule?.rhs?.value,
    minusDays: (rule) => !!rule?.rhs?.value,
    fields: (rule) => this.validateFieldsFieldType(rule),
    'field and value': (rule) => this.validateFieldAndValueFieldType(rule),
    'value and field': (rule) => this.validateValueAndFieldFieldType(rule),
    field: (rule) => this.validateFieldFieldType(rule),
    empty: (rule) => this.validateBaseRule(rule),
    custom: () => true
  };

  validRule(rule: any): boolean {
    if (!rule.field) {
      return false;
    }
    if (!rule.fieldType) {
      this.onOperatorChange(rule);
    }

    const validator = this.fieldTypeValidators[rule.fieldType];
    return validator ? validator(rule) : false;
  }

  private validateBaseRule(rule: any): boolean {
    return !!(rule.entity && rule.field && rule.operator);
  }

  private validateValueFieldType(rule: any): boolean {
    return this.validateBaseRule(rule) && this.isStringOrArrayHasValue(rule.rhs.value);
  }

  private validateValuesFieldType(rule: any): boolean {
    return (
      this.validateBaseRule(rule) &&
      this.isStringOrArrayHasValue(rule.rhs.from.value) &&
      this.isStringOrArrayHasValue(rule.rhs.to.value)
    );
  }

  private validateFieldsFieldType(rule: any): boolean {
    return (
      this.validateBaseRule(rule) &&
      !!rule.rhs.from.tableId &&
      !!rule.rhs.from.fieldId &&
      !!rule.rhs.to.tableId &&
      !!rule.rhs.to.fieldId
    );
  }

  private validateFieldAndValueFieldType(rule: any): boolean {
    return (
      this.validateBaseRule(rule) &&
      !!rule.rhs.from.tableId &&
      !!rule.rhs.from.fieldId &&
      this.isStringOrArrayHasValue(rule.rhs.to.value)
    );
  }

  private validateValueAndFieldFieldType(rule: any): boolean {
    return (
      this.validateBaseRule(rule) &&
      this.isStringOrArrayHasValue(rule.rhs.from.value) &&
      !!rule.rhs.to.tableId &&
      !!rule.rhs.to.fieldId
    );
  }

  private validateFieldFieldType(rule: any): boolean {
    return this.validateBaseRule(rule) && !!rule.rhs.tableId && !!rule.rhs.fieldId;
  }

  addRule(parent) {
    try {
      //this.isQueryChangeCheck();
      if (!this.validPreviousRule(parent)) {
        return;
      }

      let field: any = {};
      let err = false;
      let msg = '';
      let errNeeded = false;
      if (this.techStack?.textSearch == GlobalConstants.searchDbEs && this.isDefaultFilter) {
        field = Object.values(this.config.fields).find((value: any) => value.searchable) || null;
      } else {
        field = Object.values(this.config.fields)[0];
      }

      if (!field) {
        errNeeded = true;
        field = Object.values(this.config.fields)[0];
        err = true;
        msg = this.translate.instant('DEFFIL_FLD_SEARCH').replace('{field}', field?.name);
      }
      if (field && field?.value) {
        let rule: any = {
          field: field?.value ? field?.value : field?.sid,
          operator: this.qryBldrObj.getDefaultOperator(field),
          value: this.qryBldrObj.getDefaultValue(field.defaultValue),
          entity: field.entity,
          fieldType: 'value',
          lhs: {
            type: field.type
          },
          rhs: {},
          fieldOptions: [],
          sid: uuidv4()
        };
        if (this.isDefaultFilter) {
          rule = {
            ...rule,
            allowView: false,
            allowEdit: false,
            holdValue: false,
            ...(errNeeded && { err, msg })
          };
        }

        parent.rules = parent.rules.concat([rule]);
        setTimeout(() => {
          document.querySelector('ul.q-tree li:last-child')?.scrollIntoView({ block: 'nearest' });
        }, 100);
      }
    } catch (e) {
      console.error(e);
    }
  }

  addRuleSet(parent) {
    //this.isQueryChangeCheck();
    if (this.qryBldrObj.disabled) {
      return;
    }
    parent = parent || this.qryBldrObj.data;
    parent.rules = parent.rules.concat([{ condition: 'and', rules: [] }]);
    if (parent?.rules.filter((r) => r?.rules?.length === 0).length > 1) {
      this.showMessage('warn', this.translate.instant('RULESET_EMPTY_WARN'));
    }
  }

  getAllowedOperatorsForCudConditional() {
    return [
      Operators.ISEQUAL,
      Operators.ISNOTEQUAL,
      Operators.ISEMPTY,
      Operators.ISNOTEMPTY,
      Operators.ISBEFORE,
      Operators.ISAFTER,
      Operators.ISEQUALORBEFORE,
      Operators.ISEQUALORLATERTHAN,
      Operators.ISLESSTHAN,
      Operators.ISGREATERTHAN,
      Operators.ISLESSTHANOREQUALTO,
      Operators.ISGREATERTHANOREQUALTO,
      Operators.ISIN,
      Operators.ISNOTIN,
      Operators.HASANYOF,
      Operators.HASNONEOF
    ];
  }

  getInputType(field, operator) {
    this.validateCudConditionalOperator(operator);
    this.validateFieldConfiguration(field);

    const type = this.config.fields[field].type;
    return this.resolveInputTypeByOperator(operator, type);
  }

  private validateCudConditionalOperator(operator: Operators): void {
    if (this.isCudConditional && !this.getAllowedOperatorsForCudConditional().includes(operator)) {
      throw new Error(`Operator '${operator}' is not allowed for CUDConditional.`);
    }
  }

  private validateFieldConfiguration(field: string): void {
    if (!this.config.fields[field]) {
      throw new Error(`No configuration for field '${field}' could be found! Please add it to config.fields.`);
    }
  }

  private resolveInputTypeByOperator(operator: Operators, type: string): string | null {
    if (this.isEmptyOperator(operator)) {
      return null;
    }

    if (this.isMultiValueOperator(operator)) {
      return this.getMultiValueInputType(type);
    }

    if (this.isBetweenOperator(operator)) {
      return this.getRangeInputType(type);
    }

    if (this.isEqualOperatorWithDateFilter(operator, type)) {
      return 'category';
    }

    return type;
  }

  private isEmptyOperator(operator: string): boolean {
    return operator === Operators.ISEMPTY || operator === Operators.ISNOTEMPTY;
  }

  private isMultiValueOperator(operator: Operators): boolean {
    return [Operators.ISIN, Operators.ISNOTIN, Operators.HASANYOF, Operators.HASNONEOF, Operators.HASALLOF].includes(
      operator
    );
  }

  private isBetweenOperator(operator: string): boolean {
    return operator === Operators.ISBETWEEN || operator === Operators.ISNOTBETWEEN;
  }

  private isEqualOperatorWithDateFilter(operator: string, type: string): boolean {
    return operator === Operators.ISEQUAL && (type === 'date' || type === 'time') && this.isDefaultFilter;
  }

  private getMultiValueInputType(type: string): string {
    if (type === 'category' || type === 'boolean' || type === 'multiselect') {
      return 'multiselect';
    }
    if (type === 'role') {
      return 'role';
    }
    return 'chips';
  }

  private getRangeInputType(type: string): string {
    const rangeTypeMap: Record<string, string> = {
      number: 'numberrange',
      date: 'daterange',
      time: 'timerange',
      double: 'doublerange'
    };
    return rangeTypeMap[type] || type;
  }

  processRulesForQB(query) {
    if (Object.values(this.config.fields).length === 0) {
      return null;
    }
    let formattedQuery = cloneDeep(query);
    const processedRules = [];
    this.processRuleSetForQB(query, processedRules);
    formattedQuery = processedRules[0];
    return formattedQuery;
  }

  isDate = (date) => {
    const date1 = new Date(date);
    return !isNaN(Date.parse(date1.toString()));
  };

  async processRuleSetForQB(query, processedRules) {
    const formattedQuery = cloneDeep(query);
    if (
      Object.prototype.hasOwnProperty.call(formattedQuery, 'condition') ||
      Object.prototype.hasOwnProperty.call(formattedQuery, 'rules')
    ) {
      const rules = formattedQuery.rules;
      const ruleSet = [];
      processedRules.push({ condition: formattedQuery.condition, rules: ruleSet });
      rules.forEach((e) => {
        this.processRuleSetForQB(e, ruleSet);
      });
    } else {
      const e: any = formattedQuery;
      const rule: any = {};
      const fld: any = Object.values(this.config.fields)?.find((f: any) => f.sid === e.lhs?.fieldId);
      if (!fld) {
        rule.err = true;
        this.showLoader = true;
        const idSub = this.baseService.get(ApiConstants.getDeletedRecord, { sid: e.lhs?.fieldId });
        await idSub.subscribe({
          next: (res: any) => {
            this.showLoader = false;
            rule.msg = this.translate.instant('DEF_FIL_DEL')?.replace('{field}', res.name);
            const flds = cloneDeep(this.config?.fields);
            if (flds && res) {
              const configFlds = Object.values(this.config.fields);
              flds[res.sid] = { ...res, ...{ disabled: true, entity: configFlds[0]?.entity, type: 'string' } };
              this.config = { ...this.config, ...{ fields: flds } };
            }
          },
          error: (err: any) => {
            this.showLoader = false;
          }
        });
        this.subscriptions.push(idSub);
      }
      const fldCons = AllowedFieldsConstants.defaultFilter;
      const ftype = fld?.f_type?.toLowerCase();
      rule.field = e.lhs?.fieldId;
      rule.entity = e.lhs?.tableId;
      rule.operator = e.operator;
      rule.lhs = e.lhs;
      if (e.fieldType) {
        rule.fieldType = e.fieldType;
      }

      rule.rhs = {};
      if (e.rhs) {
        rule.rhs = e.rhs;
        if (e.lhs.type && (e.lhs.type === 'date' || e.lhs.type === 'time' || e.lhs.type === 'datetime')) {
          if (e.rhs.value && !this.isDefaultFilter) {
            if (this.isDate(e.rhs.value)) {
              rule.rhs.value = new Date(e.rhs.value);
            }
          }
          if (e.rhs?.from?.value) {
            rule.rhs.from.value = new Date(e.rhs?.from?.value);
          }
          if (e.rhs?.to?.value) {
            rule.rhs.to.value = new Date(e.rhs?.to?.value);
          }
        }
        if (e.lhs.type === 'double' && fld) {
          rule.minFrac = fld.f_minFrac;
          rule.maxFrac = fld.f_maxFrac;
        }
      }
      if (this.isDefaultFilter) {
        rule.allowView = e.allowView;
        rule.allowEdit = e.allowEdit;
        rule.holdValue = e.holdValue;
        if (fld?.disabled) {
          rule.err = true;
          rule.rhs = {};
          if (fldCons.f_type.includes(ftype)) {
            rule.msg = this.translate.instant('DEF_FIL_FLD_TYP').replace('{field}', fld.name);
          } else if (fldCons.searchable !== fld.searchable) {
            rule.msg = this.translate.instant('DEFFIL_FLD_SEARCH').replace('{field}', fld.name);
          } else if (!fld.operators?.includes(e.operator)) {
            rule.msg = this.translate.instant('DEFFIL_FLD_OPER').replace('{field}', fld.name);
          }
        }
        if (rule.fieldType === 'pageVariable') {
          this.configureFieldTypeForPageVariable(rule);
        }
      }
      processedRules.push(rule);
    }
  }

  configureFieldTypeForPageVariable(rule) {
    const type = rule?.lhs?.type;
    const filteredPageVariableOptions = cloneDeep(this.pageVariables);
    if (type) {
      rule.fieldOptions = [
        ...filteredPageVariableOptions
          .filter(
            (f) =>
              f.type.toLowerCase() === type.toLowerCase() ||
              (f.type.toLowerCase() === 'number' && type.toLowerCase() === 'auto-number') ||
              (f.type.toLowerCase() === 'date_only' && type.toLowerCase() === 'date') ||
              (f.type.toLowerCase() === 'date_time' && type.toLowerCase() === 'time')
          )
          .map((r) => {
            return {
              name: r.name,
              value: r.value
            };
          })
      ];
    }
  }

  processRulesForSave(query) {
    let formattedQuery = cloneDeep(query);
    const processedRules = [];
    this.processRuleSetForSave(query, processedRules);
    formattedQuery = processedRules[0];
    return formattedQuery;
  }

  onOperatorChange(rule) {
    switch (rule.operator) {
      case Operators.ISBETWEEN:
      case Operators.ISNOTBETWEEN:
        this.datefieldTypes = [
          { name: 'Value', value: 'value' },
          { name: 'Custom', value: 'custom' }
        ];
        this.rangeFieldTypes = [
          { name: 'Values', value: 'values' },
          { name: 'Custom', value: 'custom' }
        ];
        this.cd.detectChanges();
        rule.fieldType = 'values';
        this.changeFieldType(rule);
        break;
      case Operators.ISEMPTY:
      case Operators.ISNOTEMPTY:
        rule.fieldType = 'empty';
        break;
      default:
        this.datefieldTypes = [
          { name: 'Value', value: 'value' },
          { name: 'Custom', value: 'custom' },
          { name: 'Page Variables', value: 'pageVariable' },
          { name: '+ days', value: 'plusDays' },
          { name: '- days', value: 'minusDays' }
        ];
        this.rangeFieldTypes = [
          { name: 'Values', value: 'values' },
          { name: 'Custom', value: 'custom' },
          { name: 'Page Variables', value: 'pageVariable' },
          { name: '+ days', value: 'plusDays' },
          { name: '- days', value: 'minusDays' }
        ];
        this.updateCudConditionalVals();
        rule.fieldType = 'value';
        this.changeFieldType(rule);
    }
    if (this.isDefaultFilter) {
      rule.err = false;
      rule.msg = '';
      rule.allowView = false;
      rule.allowEdit = false;
      rule.holdValue = false;
    }
  }

  updateErrForRule(e, value) {
    const rules = this.query?.rules?.map((r) => {
      return r.field === e.field ? { ...r, ...{ err: value } } : r;
    });
    this.query = { ...this.query, ...{ rules: rules } };
  }

  processRuleSetForSave(rulesQuery, processedRules) {
    try {
      const rulesClone = cloneDeep(rulesQuery);

      if (this.isRuleSet(rulesClone)) {
        this.processRuleSetRecursively(rulesClone, processedRules);
      } else {
        const e = rulesClone;
        const rule: any = {};
        rule.lhs = {
          tableId: e.entity,
          fieldId: e.field,
          type: e.lhs.type
        };

        // process referred table fields which will be stored as foreignKeySid_$_fieldSid
        if (e.field?.includes('_$_')) {
          const selectedField: any = Object.values(this.config.fields).find((f) => f.value == e.field);
          if (selectedField) {
            rule.lhs = {
              ...rule.lhs,
              fkTableSid: selectedField?.fkTableSid,
              fkId: selectedField.fkId,
              fkAppId: selectedField?.fkAppId
            };
          }
        }

        rule.operator = e.operator;
        rule.fieldType = e.fieldType;
        rule.rhs = {};
        if (e.rhs) {
          rule.rhs = e.rhs;
          if (e.lhs.type && (e.lhs.type === 'date' || e.lhs.type === 'time' || e.lhs.type === 'datetime')) {
            // because for default filter value will be today/tomorrow
            if (e.rhs?.value && !this.isDefaultFilter) {
              if (this.isDate(e.rhs.value)) {
                rule.rhs.value = Date.parse(e.rhs.value);
              }
            }
            if (e.rhs?.from?.value) {
              rule.rhs.from.value = Date.parse(e.rhs?.from?.value);
            }
            if (e.rhs?.to?.value) {
              rule.rhs.to.value = Date.parse(e.rhs?.to?.value);
            }
          }
        }
        switch (e.operator) {
          case Operators.ISEMPTY:
          case Operators.ISNOTEMPTY:
            delete rule.rhs;
            break;
          default:
            break;
        }
        if (rule.err) {
          this.hasInvalidRule = true;
          return;
        }
        if (!this.validRule(e)) {
          if (this.isDefaultFilter) {
            this.updateErrForRule(e, true);
          }
          this.showMessage('error', this.translate.instant('RULE_MSG'));
          this.hasInvalidRule = true;
          return;
        }
        if (this.isDefaultFilter && !this.validDMRule(e)) {
          this.hasInvalidRule = true;
          return;
        }
        if (!this.isDefaultFilter && !this.validateBetweenRule(e)) {
          this.hasInvalidRule = true;
          return;
        }
        const fld: any = Object.values(this.config.fields)?.find((f: any) => f.sid == e?.field);
        const fieldType = fld?.f_type;
        if (
          fieldType == 'Email' &&
          e.fieldType !== 'pageVariable' &&
          e.fieldType !== 'field' &&
          ![Operators.ISEMPTY, Operators.ISNOTEMPTY].includes(rule.operator) &&
          (Array.isArray(e.rhs.value)
            ? !e.rhs.value.every((v) => this.util.isValidEmail(v)) // if array, all must be valid
            : !this.util.isValidEmail(e.rhs.value))
        ) {
          this.showMessage(
            'error',
            this.translate.instant('EMAIL_PTERN_MSG_IN_RULE').replace('{queryName}', this.qbName)
          );
          this.hasInvalidRule = true;
          return;
        }
        if (this.isDefaultFilter) {
          this.updateErrForRule(e, false);
        }
        if (this.isDefaultFilter) {
          rule.allowView = e.allowView;
          rule.allowEdit = e.allowEdit;
          rule.holdValue = e.holdValue;
          if (rule.fieldType === 'custom') {
            delete rule.rhs;
          }
        }
        processedRules.push(rule);
      }
    } catch (e) {
      console.log(e);
    }
  }

   private processSingleRuleForSave(e: any, processedRules: any[]): void {
    if (e.err) {
      this.hasInvalidRule = true;
      return;
    }

    const rule = this.buildRuleObjectForSave(e);

    // Validate rule
    if (!this.validRule(e)) {
      if (this.isDefaultFilter) {
        this.updateErrForRule(e, true);
      }
      this.showMessage('error', this.translate.instant('RULE_MSG'));
      this.hasInvalidRule = true;
      return;
    }

    if (this.isDefaultFilter && !this.validDMRule(e)) {
      this.hasInvalidRule = true;
      return;
    }

    if (!this.isDefaultFilter && !this.validateBetweenRule(e)) {
      this.hasInvalidRule = true;
      return;
    }

    // Validate email field (skip validation for page variables and field references, not actual values)
    const fld: any = Object.values(this.config.fields)?.find((f: any) => f.sid === e?.field);
    if (fld?.f_type === 'Email' && e.fieldType !== 'pageVariable' && e.fieldType !== 'field' && !this.isEmptyOperator(rule.operator)) {
      const isValidEmail = Array.isArray(e.rhs.value)
        ? e.rhs.value.every((v) => this.util.isValidEmail(v))
        : this.util.isValidEmail(e.rhs.value);

      if (!isValidEmail) {
        this.showMessage(
          'error',
          this.translate.instant('EMAIL_PTERN_MSG_IN_RULE').replace('{queryName}', this.qbName)
        );
        this.hasInvalidRule = true;
        return;
      }
    }

    if (this.isDefaultFilter) {
      this.updateErrForRule(e, false);
      rule.allowView = e.allowView;
      rule.allowEdit = e.allowEdit;
      rule.holdValue = e.holdValue;
      if (rule.fieldType === 'custom') {
        delete rule.rhs;
      }
    }

    processedRules.push(rule);
  }

  private buildLhsForSave(e: any): any {
    const lhs: any = {
      tableId: e.entity,
      fieldId: e.field,
      type: e.lhs.type
    };

    if (e.field?.includes('_$_')) {
      const selectedField: any = Object.values(this.config.fields).find((f) => f.value === e.field);
      if (selectedField) {
        lhs.fkTableSid = selectedField.fkTableSid;
        lhs.fkId = selectedField.fkId;
        lhs.fkAppId = selectedField.fkAppId;
      }
    }

    return lhs;
  }

  private buildRhsForSave(e: any): any {
    const rhs = { ...e.rhs };
    const isDateType = e.lhs.type === 'date' || e.lhs.type === 'time' || e.lhs.type === 'datetime';

    if (!isDateType) {
      return rhs;
    }

    if (rhs.value && !this.isDefaultFilter && this.isDate(rhs.value)) {
      rhs.value = Date.parse(rhs.value);
    }

    if (rhs.from?.value) {
      rhs.from.value = Date.parse(rhs.from.value);
    }

    if (rhs.to?.value) {
      rhs.to.value = Date.parse(rhs.to.value);
    }

    return rhs;
  }

  private applyDefaultFilterProperties(rule: any, e: any): void {
    rule.allowView = e.allowView;
    rule.allowEdit = e.allowEdit;
    rule.holdValue = e.holdValue;

    if (rule.fieldType === 'custom') {
      delete rule.rhs;
    }
  }

  private isRuleSet(rulesClone: any): boolean {
    return (
      Object.prototype.hasOwnProperty.call(rulesClone, 'condition') ||
      Object.prototype.hasOwnProperty.call(rulesClone, 'rules')
    );
  }

  private processRuleSetRecursively(rulesClone: any, processedRules: any[]): void {
    const rules = rulesClone.rules;
    if (rules && rules.length === 0) {
      this.hasInvalidRule = true;
      this.showMessage('error', this.translate.instant('RULESET_EMPTY_WARN'));
      return;
    }
    const ruleSet = [];
    processedRules.push({ condition: rulesClone.condition, rules: ruleSet });
    rules.forEach((e) => {
      this.processRuleSetForSave(e, ruleSet);
    });
  }
private buildRuleObjectForSave(e: any): any {
    const rule: any = {
      lhs: {
        tableId: e.entity,
        fieldId: e.field,
        type: e.lhs.type
      },
      operator: e.operator,
      fieldType: e.fieldType,
      rhs: e.rhs ? { ...e.rhs } : {}
    };

    // Handle FK fields
    if (e.field?.includes('_$_')) {
      const selectedField: any = Object.values(this.config.fields).find((f) => f.value === e.field);
      if (selectedField) {
        rule.lhs.fkTableSid = selectedField?.fkTableSid;
        rule.lhs.fkId = selectedField.fkId;
        rule.lhs.fkAppId = selectedField?.fkAppId;
      }
    }

    // Convert dates to timestamps
    const isDateType = e.lhs.type === 'date' || e.lhs.type === 'time' || e.lhs.type === 'datetime';
    if (isDateType && e.rhs) {
      if (e.rhs?.value && !this.isDefaultFilter) {
        if (this.isDate(e.rhs.value)) {
          rule.rhs.value = Date.parse(e.rhs.value);
        }
      }
      if (e.rhs?.from?.value) {
        rule.rhs.from.value = Date.parse(e.rhs.from.value);
      }
      if (e.rhs?.to?.value) {
        rule.rhs.to.value = Date.parse(e.rhs.to.value);
      }
    }

    // Remove RHS for empty operators
    if (this.isEmptyOperator(e.operator)) {
      delete rule.rhs;
    }

    return rule;
  }
  checkRhsRestrictionsBasedOnFieldType(field, rule, id) {
    let isAllowedField = field && field.entity === id;
    if (!isAllowedField) {
      return isAllowedField;
    }
    switch (rule.operator) {
      case Operators.ISIN:
      case Operators.ISNOTIN:
        isAllowedField =
          isAllowedField &&
          ((rule.lhs.type === 'string' &&
            (field.type === 'category' ||
              field.type === 'lookup' ||
              (field.type === 'string' && field.f_hasMultiVal))) ||
            (field.type === rule.lhs.type && field.f_hasMultiVal));
        break;
      case Operators.HASALLOF:
      case Operators.HASANYOF:
      case Operators.HASNONEOF:
        isAllowedField =
          isAllowedField &&
          (((rule.lhs.type === 'category' || rule.lhs.type === 'lookup') &&
            (field.type === 'category' || field.type === 'lookup')) ||
            (field.type === rule.lhs.type && field.f_hasMultiVal));
        break;
      default:
        isAllowedField = isAllowedField && field.type === rule.lhs.type;
    }
    return isAllowedField;
  }

  getEntityFields(id, rule) {
    if (id && this.config.fields) {
      let allFields = Object.values(this.config.fields);

      if (this.isDefaultFilter) {
        allFields = allFields.filter((field: any) =>
            field.name.toLowerCase() !== 'sid' &&
            field.name.toLowerCase() !== 'sync time' &&
            field.name.toLowerCase() !== 'pid'
        );
      }

      const incompatibleTypes = ['File Attachments', 'Image Carousel', 'Image', 'JSON'];
      const compatibleFields = allFields.filter((field: any) => {
        return field && !incompatibleTypes.includes(field.f_type);
      });

      if (id.startsWith('currentUser')) {
        return compatibleFields.filter((field: any) => {
          return this.checkRhsRestrictionsBasedOnFieldType(field, rule, id) && field.type !== 'role';
        });
      }
      return compatibleFields.filter((field) => {
        return this.checkRhsRestrictionsBasedOnFieldType(field, rule, id);
      });
    }
    return [];
  }

  onSelectDateValue(value, rule, field) {
    const date = new Date(value);
    rule.rhs.value = Date.parse(value);
  }

  showQueriesList() {
    if (this.showQueries) {
      return;
    }
    this.showQueries = true;
    this.currentTableName = this.qbService.currentTableName;
    this.store.dispatch(setQBQueries({ qbQueries: null }));
    this.store.dispatch(
      getQBQueries({
        apiConstants: ApiConstants.getQueriesListByTableId,
        params: { tableId: this.qbService.currentTableId }
      })
    );
    this.isPopupLoader = true;
    this.showQueriesSub = this.store
      .select(qbQueries)
      .pipe(distinctUntilChanged())
      .subscribe((queries: any) => {
        if (queries === null || queries === undefined) {
          this.allQueries = [];
          return;
        }
        let queriesList = [...queries];
        let filteredQueries: any[] = [];
        if (this.isDatamodelField) {
          queriesList = queriesList.filter((e) => e.usedIn == 'FIELD');
        }
        if (this.isTableLevelAcl) {
          queriesList = queriesList.filter((e) => e.usedIn == 'RECORD');
        }
        if (this.isWorkflowAcl) {
          queriesList = queriesList.filter((e) => e.usedIn == 'WORKFLOW');
        }
        if (this.isCudConditional) {
          queriesList = queriesList.filter((e) => e.usedIn == 'CUD');
        }
        if (this.isFromPage) {
          queriesList = queriesList.filter((e) => e.usedIn == 'PAGE');
        }
        filteredQueries = queriesList;
        // Exclude the current query from the copy list
        if (this.qbObject?.sid) {
          filteredQueries = filteredQueries.filter((e) => e.sid !== this.qbObject.sid);
        }
        this.allQueries = filteredQueries;
        this.isPopupLoader = false;
        this.cd.detectChanges();
        this.showQueriesSub.unsubscribe();
      });
    this.subscriptions.push(this.showQueriesSub);
  }

  updateQuery() {
    try {
      if (!this.selectedQuery) {
        this.confirmationDialogService.confirm({
          message: 'Please select the query name to copy or click on close button to close the window',
          acceptLabel: this.translate.instant('OK'),
          accept: () => {
            this.showQueries = true;
          },
          rejectVisible: false
        });
        return;
      }
      this.showQueries = false;
      this.query = this.processRulesForQB(JSON.parse(this.selectedQuery.query));
      this.qbName = this.selectedQuery.queryName;
      this.description = this.selectedQuery.queryDescription;
      this.rulesCopied = true;
      if (this.qbObject) {
        this.qbObject.sid = this.selectedQuery.sid;
      } else {
        this.qbObject = { sid: this.selectedQuery.sid };
      }
      this.references = [];
      //this.processReferences(this.selectedQuery.references);
      this.isExist = true;
      this.tabIndex.set(0);
      this.cd.detectChanges();
    } catch (e) {
      console.log(e);
    }
  }

  getFieldName(fieldId) {
    return this.fieldIdMap[fieldId];
  }

  getRoleName(roleId) {
    const role = this.allRoles?.results?.filter((e) => e.sid === roleId);
    return role ? startCase(role[0].shortName) : roleId;
  }

  findActonNode(workflowOrder, actionId) {
    let obj;
    workflowOrder.some((status) => {
      status?.children.some((actor) => {
        actor?.children.some((action) => {
          if (action.data.sid === actionId) {
            obj = action;
            return obj;
          }
        });
      });
    });
    return obj;
  }

  getActorAndActionName(actionInfo, obj) {
    try {
      obj.action = actionInfo.data.action;
      const actorInfo = actionInfo?.parent;
      if (actorInfo) {
        obj.status = actorInfo.parent.data.name;
        const names: any = [];
        const actors = JSON.parse(actorInfo.data.actor);
        actors.forEach((e) => {
          if (e.type === 'role') {
            const values = e.value.split(',');
            values.map((role) => {
              names.push(this.getRoleName(role));
            });
          } else if (e.type === 'field') {
            const values = e.value.split(',');
            values.map((field) => {
              names.push(this.getFieldName(field));
            });
          }
        });
        obj.actor = names.join();
      }
    } catch (e) {
      console.error(e);
    }
  }

  clearQuery() {
    if (this.isQueryEmpty) {
      return;
    }
    this.confirmationDialogService.confirm({
      message: this.isDefaultFilter ? this.translate.instant('CLR_DEF') : this.translate.instant('CLR_QRY'),
      accept: () => {
        const existed = this.isExist;
        const sid = this.qbObject?.sid;
        this.qbName = '';
        this.description = '';
        this.query = '';
        this.selectedQuery = null;
        this.references = null;
        this.qbObject = null;
        this.set(null);
        let obj = {
          cleared: true,
          sid: true
        };
        if (existed) {
          this.onClear.emit(obj);
        }
        // Since query builder is cleared and API is called to remove the query, we need to reset the backup as well
        // not only on this.isDefaultFilter but for all cases
        this.createInitalObject();
      },
      reject: () => {
        /* empty */
      }
    });
  }

  clearQueryBuilder() {
    this.clearQuery();
    this.qbObject = null;
  }
  updateCudConditionalVals() {
    if (this.isCudConditional) {
      const removeVals = ['custom', 'pageVariable', 'plusDays', 'minusDays'];
      this.datefieldTypes = this.datefieldTypes.filter((opt) => !removeVals.includes(opt.value));
      this.rangeFieldTypes = this.rangeFieldTypes.filter((opt) => !removeVals.includes(opt.value));
    }
  }

  getTableFields(getter: any, entity: any) {
    let fields = getter(entity);
    if (this.isCudConditional) {
      fields = fields.filter((f) => f.f_type !== 'Auto-number');
    }
    return fields;
  }
}




